export default {
  "SpecialData": {
    "ipv4Mask": "后路由IPV4地址掩码",
    "addProfile": "新增个性化签约",
    "mnc": "网络码",
    "modProfileSuccess": "修改个性化签约成功",
    "addProfileSuccess": "添加个性化签约成功",
    "qryProfileSuccess": "查询个性化签约成功",
    "specialSign": "个性化签约",
    "modProfile": "修改个性化签约",
    "mcc": "国家码",
    "delProfileSuccess": "删除个性化签约成功",
    "supi": "SUPI",
    "ipTypeNotNull": "静态地址类型不能为空",
    "ipv6Addr": "静态IPV6地址",
    "sd": "SD",
    "staticIpForbid": "静态地址签约",
    "crumb": "开户管理/UDM管理/个性化管理",
    "sst": "SST",
    "staticIpv6Prefix": "静态IPV6前缀",
    "dnnName": "接入点名称",
    "ipv4Addr": "静态IPV4地址",
    "ipv6Prefix": "后路由IPV6前缀",
    "conflict": "静态地址类型冲突"
  },
  "Pvi": {
    "op": "OP",
    "pvi": "PVI",
    "pviSearch": "输入PVI进行查询",
    "addPviSuccess": "添加PVI成功",
    "qryPviSuccess": "查询PVI成功",
    "modPvi": "修改PVI",
    "delPviSuccess": "删除PVI成功",
    "modPviSuccess": "修改PVI成功",
    "crumb": "开户管理/VONR管理/PVI",
    "addPvi": "新增PVI",
    "addBatchPvi": "批量新增PVI",
    "amf": "鉴权管理域",
    "ki": "KI"
  },
  "DNN": {
    "ambrUp": "DNN上行AMBR(Kbps)",
    "addProfileSuccess": "添加DNN模板成功",
    "qryProfileSuccess": "查询DNN模板成功",
    "sscMode": "SSC模式",
    "dnnParamInfo": "DNN参数",
    "delProfileSuccess": "删除DNN模板成功",
    "pec": "ARP可抢占",
    "commonError15": "用户数量达到License上限",
    "commonError14": "标识重复",
    "lboRoamingAllowed1": "允许",
    "dnnName": "接入点名称",
    "pev": "ARP可被抢占",
    "max16": "不可超过16条",
    "dftPduSessionType": "默认PDU会话类型",
    "defaultIndicator1": "默认",
    "qosParamInfo": "Qos参数",
    "profileId": "DNN模板ID",
    "profileName": "模板名称",
    "dftSscMode": "默认SSC模式",
    "disabledPec": "不可抢占",
    "pduType1": "IPv6",
    "ambrDown": "DNN下行AMBR(Kbps)",
    "pduType2": "IPv4v6",
    "pduType0": "IPv4",
    "sscModeParamInfo": "SSC模式参数",
    "defaultIndicator": "默认指示符",
    "pduType3": "TRUCTURED",
    "pduType4": "ETHERNET",
    "enabled": "可被抢占",
    "enabledPec": "可抢占",
    "crumb": "开户管理/UDM管理/DNN模板",
    "pduSessionType": "PDU会话类型",
    "sscMode2": "SSC_MODE_3",
    "disabled": "不可被抢占",
    "notDefaultIndicator0": "非默认",
    "lboRoamingAllowed": "漫游时是否允许lbo",
    "sscMode0": "SSC_MODE_1",
    "chargeChars": "计费特性",
    "sscMode1": "SSC_MODE_2",
    "fiveQiPriorityLevel": "5QI优先级",
    "max4": "不可超过4条",
    "modProfileSuccess": "修改DNN模板成功",
    "fiveQi": "5QI",
    "commonError11": "PLMN模板关联了用户签约模板",
    "commonError10": "AM-DATA模板关联了PLMN模板",
    "commonError13": "请求参数格式错误",
    "commonError12": "用户签约模板关联了用户",
    "commonError9": "切片关联了PLMN模板",
    "commonError8": "DNN关联了切片",
    "commonError7": "批量操作数量超过上限",
    "commonError6": "网元内部错误",
    "commonError5": "网元内部错误",
    "commonError4": "参数缺失",
    "commonError3": "请求消息解码失败",
    "commonError2": "模板已存在",
    "commonError1": "模板不存在",
    "notAllowed": "不允许",
    "commonError0": "成功",
    "pl": "ARP优先级",
    "pduSessionParamInfo": "PDU会话参数",
    "max1": "不可超过1条"
  },
  "Usersub": {
    "profileName": "模板名称",
    "plmnProfileIds": "关联PLMN模板",
    "addProfile": "新增用户签约模板",
    "modProfileSuccess": "修改用户签约模板成功",
    "addProfileSuccess": "添加用户签约模板成功",
    "qryProfileSuccess": "查询用户签约模板成功",
    "modProfile": "修改用户签约模板",
    "plmnInfos": "PLMN",
    "delProfileSuccess": "删除用户签约模板成功",
    "crumb": "开户管理/UDM管理/用户签约模板",
    "profileId": "用户签约模板ID",
    "plmnProfileName": "PLMN模板名称",
    "plmnProfileId": "关联PLMN模板ID"
  },
  "SubscriberIms": {
    "cancel": "取消",
    "userInfo": "用户信息",
    "impFileTypeErrTip": "导入的数据格式不对",
    "notModRootTip": "无法修改顶级节点",
    "mod": "修改",
    "batchAddUserTip": "批量开户",
    "del": "删除",
    "serviceProfileInfoDiv": "用户服务信息",
    "chooseUserDataTip": "请选择用户数据",
    "userTemplate": "开户模板",
    "zoneTip": "区号范围须在328~806",
    "logTitle": "日志",
    "maxlen15": "不能超过15个字符",
    "unitCode": "单位代码",
    "rtttype2": "系统调度台",
    "profession": "职务名称",
    "exportdata": "导出",
    "substatus2": "摇毙",
    "selectVButton": "选择",
    "rtttype8": "统一定位系统",
    "preDelChildNode": "请先删除子节点",
    "checkDataMoreTip": "只能选择一条数据",
    "rtttype6": "宽带终端",
    "modUserMember": "修改隶属用户",
    "checkDateLessTip": "请选择多条数据",
    "rtttype4": "双模终端",
    "rtttype5": "录音/录像服务器",
    "temptype": "模板类型",
    "activetime": "激活时间",
    "groupName": "组名称",
    "temTitle": "开户管理/IMS管理/模板管理",
    "notFitDialPlan": "组号码不符合拨号方案规则",
    "deleteUser": "删除用户",
    "grpNumTitle": "*组号码:\r\n符合拨号方案",
    "dyGroupNotConfigLSGX": "动态组不支持添加隶属关系",
    "regstatus": "注册状态",
    "noZoneDial6Tip": "数据范围是000到999",
    "menuTitleUserMcs": "开户管理/MCS管理/用户管理",
    "supplementaryInfoDiv": "用户补充信息",
    "noOperatRole": "该节点没有操作权限",
    "template": "宽带模板",
    "notDelRootNode": "顶级节点不能删除",
    "grpnumrange": "输入值必须在1到99999999之间",
    "fuzzyQryNotApplSort": "模糊查询不支持排序",
    "noZoneDial1Tip": "数据范围是900到999",
    "search": "搜索",
    "regstatus1": "注册",
    "regstatus0": "非注册",
    "requestResTip": "请求失败，请检查地址和参数",
    "impugrpclass": "用户组内权限",
    "staffName": "职员名称",
    "solid_5": "固定5位数字",
    "impuinfoDiv": "用户基础信息",
    "userNumTitle": "*用户号码:\r\n符合拨号方案",
    "substatus1": "摇晕",
    "addGroup": "开组",
    "close": "关闭",
    "substatus0": "正常",
    "createtime": "创建时间",
    "reminder": "提示",
    "tempname": "模板名",
    "qryDialPlanFailTip": "拨号方案查询失败",
    "solid_3": "固定3位数字",
    "batchModUserTip": "批量修改",
    "menuTitle": "开户管理/IMS管理/群组管理",
    "batchModUser": "批量修改",
    "notAddNetgate": "网关类用户禁止加入组",
    "lsgxInfo": "隶属关系配置信息",
    "batchModGroup": "批量修改",
    "loadingvpn": "VPN载入",
    "numTip": "个号范围是00001~29999或30019~32767",
    "invalideChar": "无效的特殊字符",
    "waitTip": "请稍候......",
    "notSuppoDialTip": "网管不支持此拨号方案",
    "confirm": "确定",
    "endNOLessStartNo": "截止个号应大于起始个号",
    "noZoneDial4Tip": "数据范围是00000到99999",
    "insertStaffName": "请输入职员名称",
    "qryUserMember": "查询隶属用户",
    "notModWithDifTypeTip": "不同类型不允许修改",
    "insertName": "请输入名称",
    "organization": "组织架构",
    "importdata": "导入",
    "qryVpnFailTip": "查询组织架构失败",
    "operObj": "操作对象",
    "menuTitleUser": "开户管理/IMS管理/用户管理",
    "register": "已注册",
    "infoTitle": "开户管理/IMS管理/人员信息管理",
    "addSiblingNode": "添加同级节点",
    "addChildNode": "添加子节点",
    "noDataCanOper": "没有可以操作的数据",
    "noCheckDataTip": "请选择一条数据",
    "addUser": "开户",
    "use": "用途类型",
    "groupTemplate": "开组模板",
    "sortBtn": "排序",
    "chooseNodeTip": "请选择节点",
    "batchAddGroup": "批量开组",
    "post": "工种",
    "find": "查询",
    "grpAttribute": "组特性",
    "checkVpnTip": "请选择组织架构",
    "export": "导出(按搜索条件)",
    "neList": "网元列表",
    "group": "组",
    "info": "信息",
    "add": "添加",
    "all": "全部",
    "notAddDynamicsTip": "禁止加入动态组",
    "nelist": "网元列表",
    "passwordEqual": "密码与确认密码要保持一致",
    "unitName": "单位名称",
    "substatus": "设备状态",
    "grptype0": "普通组",
    "grpIdentity": "组标识号",
    "grptype2": "混合组",
    "licenseNum": "车牌号",
    "grptype1": "漫游组",
    "grptype4": "分级组",
    "grptype3": "跨系统组",
    "addGroupMember": "添加隶属组",
    "qryGroupMember": "查询隶属组",
    "warn": "警告",
    "qryDataError": "设备侧返回数据错误",
    "tempdate": "创建时间",
    "staffTitle": "人员信息",
    "invalidInt": "无效的整数",
    "vpnid": "组织架构id",
    "rtttype": "用户类型",
    "userManagement": "IMS用户管理",
    "groupType": "组类型",
    "addUserMember": "添加隶属用户",
    "import": "导入",
    "userNo": "用户号码",
    "grpproperty": "组属性",
    "tempnum": "模板号",
    "operResult": "操作结果",
    "nodesCountTip": "最多添加6级节点",
    "hour": "时",
    "delUserMember": "删除隶属用户",
    "batchAddUser": "批量开户",
    "toomuchUsers": "批量开户数量不能超过1000",
    "grpproperty0": "静态组",
    "clusterGroupCreate": "用户开组",
    "chooseGroupDataTip": "请选择组数据",
    "grpproperty1": "动态组",
    "groupProfileInfoDiv": "组服务信息",
    "resultReturnFailedTip": "返回结果有误，请联系管理员",
    "groupNo": "组号码",
    "tgrpserviceDiv": "组服务信息",
    "noSortVpn": "没有需要排序的节点",
    "terType": "终端类型",
    "numDialTip9": "数据范围是200到549",
    "impugrppriority": "用户组内优先级",
    "noDialTip": "没有查询到拨号方案",
    "numDialTip7": "数据范围是00001到99999",
    "numDialTip8": "数据范围是200到899",
    "checkZoneTip": "请校验区号",
    "numDialTip5": "数据范围是100到109",
    "numDialTip6": "数据范围是200到899",
    "mobile": "手机号",
    "unregister": "未注册",
    "deleteConfirm": "确认删除选中的数据吗?",
    "DMRZoneTip": "DMR拨号方案区号须为2位",
    "dialogListSpan": "操作完成，成功",
    "modGroup": "修改组",
    "userName": "用户名称",
    "modifyNode": "修改节点",
    "minute": "分",
    "qryAdvance": "高级查询",
    "menuTitleGroupMcs": "开户管理/MCS管理/群组管理",
    "controlMember": "组成员管理",
    "operSucess": "操作成功",
    "modUser": "修改用户",
    "numDialTip3": "数据范围是00001到32767",
    "notChooseRootTip": "无法添加主节点的平级节点",
    "clusterUserCreate": "用户开户",
    "numDialTip4": "数据范围是00001到29999,30019到32767",
    "numDialTip1": "数据范围是100到109",
    "numDialTip2": "数据范围是00000到99999",
    "fresh": "刷新",
    "user": "用户",
    "subNum": "用户号码",
    "staffId": "职员编号",
    "templateinfDiv": "模板基础信息"
  },
  "Index": {
    "help": "帮助",
    "exit": "退出",
    "custom": "个性化设置",
    "about": "关于",
    "pwdFreq": "密码更改过于频繁,密码修改间隔时间不得少于{0}分钟",
    "pwdRepeat": "新密码不能与最近使用过的密码相同",
    "myAccount": "我的账号",
    "version": "版本",
    "downloadhelp": "下载帮助"
  },
  "Security": {
    "userInfo": "用户信息",
    "clientRules": "地址规则",
    "uploadFile":"上传文件",
    "auth": {
      "search": "网元检索",
      "domain": "域权限",
      "ne": "网元分域",
      "clusterSearch": "集群检索",
      "deviceSearch": "设备检索",
      "fun": "功能权限"
    },
    "addUser": "新增用户",
    "deleteLog": "点击确认按钮将删除数据库记录，若不想删除请点击关闭按钮。\u003cbr/\u003e删除数据库记录之前，请检查导出的日志",
    "pwdStrategy": "密码策略",
    "editUser": "修改用户",
    "userManage": "用户管理",
    "loginLog": "登录日志",
    "selectDate": "选择日期",
    "roleNameExists": "角色已存在",
    "device5G": "5G设备",
    "unActive": "失活",
    "accountMonitor": "用户监控",
    "operateCalc": "操作统计",
    "userStrategy": "用户策略",
    "weekNotNull": "星期不能为空",
    "timeStrategy": "时间策略",
    "selectTimePolicy": "请选择时间策略",
    "operateLog": "操作日志",
    "defaultPolicyNotEdit": "默认策略禁止编辑",
    "group": {
      "groupName": "用户组名称",
      "editGroup": "修改用户组",
      "name": "用户组",
      "addGroup": "添加用户组"
    },
    "strategyNameExist": "策略名称已存在",
    "add": "新增",
    "Log": {
      "result": "执行结果",
      "loginResult": "登录结果",
      "loginTime": "登录时间",
      "feature": "功能",
      "module": "模块",
      "ip": "IP",
      "resultData":"结果数据",
      "execTime": "执行时间",
      "execType": "执行类型"
    },
    "adminGroupCannotModify": "默认用户组不允许修改",
    "userIPSet": "用户IP设置",
    "active": "激活",
    "history": "历史记录",
    "inputRoleName": "请输入角色名称",
    "authInfo": "权限信息",
    "Role": {
      "cluster": "集群权限",
      "creator": "创建人",
      "createTime": "创建时间",
      "el": "网元权限",
      "name": "角色名称",
      "device": "设备权限"
    },
    "groupManage": "用户组管理",
    "dateCompare": "起始日期不能大于结束日期",
    "install": "安装",
    "failure": "失败",
    "failureMessage": "任务名重复",
    "pwdNotMatch": "密码与确认密码不一致",
    "success": "成功",
    "forbid": "禁止",
    "exportTimeNotNull": "导出时间不能为空",
    "adminGroupCannotDelete": "默认用户组不允许删除",
    "copyUser": "复制用户",
    "northGatewayLog": "北向日志",
    "userExist": "用户已存在",
    "device": "设备",
    "addRole": "新增角色",
    "defaultPolicyNotDel": "默认策略禁止删除",
    "timeNotNull": "时间不能为空",
    "timeCompare": "起始时间不能大于结束时间",
    "User": {
      "operateCount": "操作次数",
      "operateTime": "操作时长",
      "start": "启用",
      "confirmpwd": "确认密码",
      "realname": "真实名称",
      "password": "用户密码",
      "expireDay": "失效日期",
      "abandon": "停用",
      "phone": "电话",
      "operatetime": "上次操作时间",
      "lock": "锁定",
      "idletime": "空闲时间(分)",
      "force": "强制退出",
      "email": "邮箱",
      "desc": "描述",
      "username": "用户名称",
      "status": "用户状态",
      "timeoutstatus": "超时状态",
      "inactiveInterval": "登录系统后无活动会话有效时长(分钟)",
      "forbidenDel": "不允许删除超级管理员"
    },
    "roleNameNotNull": "角色名不能为空",
    "authorityManage": "权限管理",
    "delete": "删除",
    "roleInfo": "角色信息",
    "editTimePolicy": "修改时间策略",
    "client": {
      "addresses": "绑定地址",
      "startAddress": "起始地址",
      "addClient": "新增规则",
      "editClient": "修改规则",
      "endAddress": "终止地址"
    },
    "placeholder": {
      "strategyName": "请输入策略名称",
      "password": "请输入用户密码",
      "inputInteger": "请输入整数",
      "mail": "请输入邮箱",
      "phone": "请输入电话",
      "startAddress": "请输入起始地址",
      "confirmpwd": "请输入确认密码",
      "endAddress": "请输入终止地址",
      "username": "请输入账户名称",
      "realname": "请输入真实名称",
      "fileName": "请指定文件名称",
      "inactiveInterval": "请输入登录系统后无活动会话有效时长(分钟)"
    },
    "logManage": "日志管理",
    "editRole": "修改角色",
    "strategyManage": "策略管理",
    "securityManage": "安全管理",
    "validate": {
      "special": "请输入至少包含一个特殊字符的组合",
      "mixedPassword":"请输入数字、小写字母、大写字母、特殊字符的组合",
      "addressCompareErr": "起始IP应小于终止IP",
      "noSpecial": "请输入数字、小写字母、大写字母的组合",
      "phone": "电话号码格式错误",
      "minLength": "请输入至少{0}个字符",
      "ip": "IP地址格式错误",
      "maxLength": "请输入少于{0}个字符",
      "addressRangeErr": "IP地址不在相同地址段",
      "email": "请输入有效的电子邮件地址",
      "ipError": "IP地址错误",
      "chooseUser": "请选择用户",
      "inactiveInterval": "请输入10-120之间的整数"
    },
    "roleManage": "角色管理",
    "selectAccount": "请选择用户",
    "userGroupInfo": "用户组信息",
    "Lic": {
      "userCount":"授权最大用户数",
      "mysqlUserName":"mysql用户名",
      "nbi":"北向接口",
      "bsCount":"授权数量基站",
      "startTime":"授权起始时间",
      "expiredTime":"授权截止时间",
      "curUserCount":"当前登录用户数",
      "curBsCount":"当前管理的基站数量",
      "voice": "并发语音呼叫路数",
      "installed": "已安装license",
      "esn": "ESN",
      "unUpload": "未上传license",
      "maxNumberOfUe": "开户数",
      "uploadStatus": "上传状态",
      "installTime": "安装时间",
      "numberOfStation": "基站数",
      "caps": "用户会话数",
      "activeLicense_warntip": "设备license已经激活，不能操作",
      "activeLicense_warntip2": "请先安装license",
      "uploadStatus_uploaded": "已上传",
      "vedio": "并发视频呼叫路数",
      "slice": "切片数",
      "activeLicense_warntip1": "请先上传license",
      "unActiveLicense_warntip1": "请先激活license",
      "sn": "SN",
      "normal": "正常",
      "activeStatus_activated": "已激活",
      "currentStatus": "状态",
      "activeTime": "激活时间",
      "loseEfficacy": "已失效",
      "licenseHistoryDetail": "License历史详情",
      "uploadTime": "上传时间",
      "licenseDetail": "License详情",
      "activeStatus": "激活状态",
      "activeStatus_inactivated": "未激活",
      "activeLicense": "请先激活设备License",
      "throughPut": "吞吐量",
      "installStatus": "已安装",
      "uploadStatus_unupload": "未上传",
      "syncDevLicense_warntip": "只能同步未上传过license的设备"
    },
    "LicenseManage": "License管理",
    "IPRangeSet": "IP范围设置",
    "EadminCannotDelete": "Eadmin角色不允许删除",
    "modify": "修改",
    "addTimePolicy": "新增时间策略",
    "device4G": "4G设备",
    "mysqlUserSettings": "Mysql用户设置",
    "verifyPasswordConsistency":"两次输入的密码不一致",
    "passwordVerificationPrompt":"密码要求包含数字、字母、大小写字母，且长度至少为8个字符",
    "passwordModifiedSuccessfully":"Mysql密码修改成功",
    "passwordModifiedFailed":"Mysql密码修改失败",
    "dateNotNull": "日期不能为空",
    "Strategy": {
      "date": "日期",
      "accountMinNumber": "账户最小字符个数",
      "accountInactiveInterval": "默认用户登录系统后无活动会话有效时长(分钟)",
      "accountLoginInterval": "超过几天未登录系统禁用账户(天)",
      "onlyNumChar": "包含数字、小写字母、大写字母的组合",
      "saturday": "星期六",
      "endDate": "终止日期",
      "weekday": "星期",
      "pwdPeriod": "密码有效期",
      "lockTime": "锁定时长(分钟)",
      "remindDay": "在到期前几天通知密码更改",
      "friday": "星期五",
      "wednesday": "星期三",
      "startTime": "起始时间",
      "monday": "星期一",
      "shortInterval": "密码修改最短时间间隔(分钟)",
      "accountLock": "账户锁定策略",
      "thursday": "星期四",
      "failTimes": "限定时间段内连续登录失败次数",
      "constitute": "密码组成",
      "updPwd": "过期时强制更改密码",
      "pwdMinNumber": "密码最小字符个数",
      "pwdHistoryLimit": "限定时间内的历史密码不允许相同(天)",
      "special": "至少包含一个特殊字符:!#$%\u0026*+-/\u003c\u003d\u003e?@[]^{_}~",
      "mixedPassword":"包含数字、小写字母、大写字母、特殊字符的组合",
      "sunday": "星期日",
      "tuesday": "星期二",
      "lockPeriod": "指定时间段长度(分钟)",
      "name": "策略名称",
      "to": "至",
      "time": "时间",
      "endTime": "终止时间",
      "updTipInfo": "策略修改后，将在用户下次登录时生效。",
      "lockOn": "永久锁定",
      "startDate": "起始日期"
    },
    "EadminCannotModify": "Eadmin角色不允许修改",
    "fileType": "文件类型",
    "assetManagement": "资产管理",
    "assetStatistics": "资产统计",
    "hwinfoAsset": "硬件资产",
    "sfpAsset": "光模块资产",
  },
  "System": {
    "dataTotal": "数据总量(条)",
    "systemFile": "系统文件",
    "cancel": "取消",
    "inputTipPort": "请输入端口号",
    "curAlarmData": "当前告警数据",
    "tableName": "表名称",
    "inputVersion": "请输入版本号内容进行查找",
    "hostname": "主机名",
    "epcOAM": "EPC平台",
    "productVersion": "产品版本",
    "itemName": "项名称",
    "continueRun": "继续执行",
    "state": "当前状态",
    "mapLngLimit": "请输入合法的精度,精度范围 [-180,180]",
    "backDelTime": "备份时间或删除时间不能为空",
    "busSet": "业务操作",
    "remoteTip": "远程通知需要设置对应的远程通知用户组。你可以增加、修改或删除用户.",
    "module": "模块",
    "importSuccess": "上传成功，后台配置文件中.....",
    "ibs_b": "iBS-B",
    "groupExists": "用户组已存在",
    "personal": "个性化",
    "keyString": "请输入关键字搜索",
    "keyStringDetail": "请输入详情中的关键字进行搜索",
    "version": "软件版本",
    "node": "网元",
    "smtpCheckTip": "SMTP服务器要求身份验证（SMTP服务器访问控制为\"基本身份验证\"时，需启用该选项）",
    "ThresholdConfig": "网管资源阈值配置",
    "systemLogo": "系统logo",
    "ri": "日",
    "ftpPortTip": "1~65535",
    "processing": "处理中...",
    "missResol": "错误处理",
    "taskName": "任务名称",
    "uploadTipsSize": "上传图片不能超过2MB",
    "selectDelObj": "请选择删除对象",
    "weeks": "周",
    "centerLon": "地图中心经度",
    "configMenu": "配置菜单",
    "ftpUser": "FTP用户名",
    "num1000": "1000条",
    "backupType": "备份类型",
    "result": "执行结果",
    "delTask": "删除定时任务",
    "mcsOAM": "MCS平台",
    "inputTip11": "输入项名称、表名、更新时间",
    "inputTip7": "请输入关键字进行搜索",
    "inputTip8": "请输入补丁包名关键字进行搜索",
    "inputTip20": "请输入设备ID或名称进行搜索",
    "inputTip21": "请输入设备ID进行搜索",
    "taskFilter": "高级搜索",
    "minuteRangeInvalid": "分钟时间隔应该在1-59内",
    "inputTip5": "删除n天前的记录",
    "inputTip6": "删除n条前的数据",
    "inputTip3": "执行n天前的记录",
    "close": "关闭",
    "inputTip4": "执行n条前的数据",
    "addPkg": "添加版本包",
    "inputTip1": "输入项名称、表名、创建时间",
    "email": "邮件地址",
    "inputTip2": "1-255个英文字符",
    "serviceSet": "服务器设置",
    "uploadFile": "开始上传",
    "systemQuery": "系统查询",
    "loginAuthenticationMode": "登录认证方式",
    "loginAuthenticationMode1": "网管认证",
    "loginAuthenticationMode2": "kerberos认证",
    "ldapServerConf": "LDAP服务配置",
    "backupAndDel": "备份并删除",
    "dataLength": "数据长度(M)",
    "smtpTip": "SMTP服务器域名/IP地址",
    "takeTime": "耗时",
    "selectOneMessage": "请选择一条数据",
    "inputMailTip": "请输入标题搜索",
    "upFileTip": "只能上传zip文件，不超过500M",
    "selectedUser": "已选用户",
    "MemoryUsage": "内存使用率(%)",
    "reSuccess": "成功",
    "taskPastDue": "任务已过期",
    "tableCreateTime": "表创建时间",
    "changeTime": "修改时间",
    "confirm": "确定",
    "topoConfig": "拓扑设置",
    "createGroupInfo": "创建用户组信息",
    "busData": "事件数据",
    "createTime": "创建时间",
    "missManager": "任务管理",
    "endTime": "结束时间",
    "config": "配置",
    "configBackupAndRecover": "配置备份与恢复",
    "oprTime": "操作时间",
    "db": "DB",
    "inputTip": "请输入内容",
    "activeTask": "激活",
    "exportFail": "基站未响应，导出失败，请重新操作 .....",
    "dayRangeInvalid": "天间隔应该在1-31内",
    "stopRun": "终止执行",
    "nextTime": "下次时间",
    "geWeek": "个星期",
    "editTime": "编辑时间",
    "topoalarmConfig": "是否显示各级告警的数目",
    "ftpAddressTip": "例如:192.168.1.1",
    "selectOprSet": "选择操作集合",
    "tip": "提示",
    "uploadingFile": "文件正在上传...",
    "ims_hytalk": "IMS_HYTALK平台",
    "export": "导出",
    "exportAll": "全量导出",
    "pmBusManager": "性能业务数据管理",
    "area": "占用空间(MB)",
    "add": "添加",
    "serialNumber": "流水号",
    "test": "测试",
    "applyAndTest": "测试",
    "uploadImgWith": "83",
    "ftpPassword": "FTP密码",
    "timeRangeNotNull": "时间间隔不能为空",
    "telephone": "手机号码",
    "backupNum": "备份条数",
    "fileTypeError": "上传配置文件类型错误,请使用XLSX",
    "uploadFault": "上传失败",
    "warn": "警告告警",
    "month": "月",
    "resultTip": "结果",
    "port": "端口",
    "backDelRange": "备份容量或删除容量不能为空",
    "userGroupName": "用户组名",
    "takeTimeWithUnit": "耗时(秒)",
    "saveMapSuccess": "保存成功",
    "editUserInfo": "编辑用户信息",
    "runCycles": "执行周期",
    "uploadConfirm": "是否确认上传",
    "systemManager": "系统管理",
    "fm": "性能",
    "description": "描述",
    "searchC": "搜索分类",
    "curMoKey": "字段属性",
    "curMoValue": "当前值",
    "selectFileTip": "只能上传.txt文件，且不超过1MB",
    "num5000": "5000条",
    "emailNotNull": "请输入邮箱地址",
    "centerLonInput": "请输入地图中心的经度",
    "uGroup": "用户组",
    "missLogs": "任务日志",
    "soundTip": "只能上传mp3音频文件，且不超过2MB",
    "isRunning": "正在执行",
    "acArea": "按容量",
    "beforeDay7": "7天前",
    "uploadTipsWidth": "上传图片宽度不能超过83像素",
    "every": "每",
    "uploadSoundTipsType": "只能上传mp3文件",
    "deleteFile": "文件正在删除...",
    "testLoading": "正在测试服务器能否接通...",
    "telephoneOrEmail": "请输入邮箱和手机号码其中的至少一项.",
    "mailTip": "提示：设置本系统与邮箱服务器对接参数，以建立两者间通信。当启用邮件通知功能后，系统自动发送邮件通知用户。为了保证发送邮件的安全性，推荐采用SSL/TLS(Secure Sockets Layer)安全连接",
    "exportSuccess": "后台导出文件中.....",
    "apply": "应用",
    "yes": "是",
    "mcscl": "MCSCL平台",
    "geYueDi": "个月第",
    "oprType": "操作类型",
    "ftpTest": "FTP测试",
    "pngTip": "只能上传png文件，且不超过2MB，尺寸83x35像素.(建议图片背景透明)",
    "remoteSave": "远端保存",
    "inputNumber": "请输入数字",
    "pleaseChoose": "请选择",
    "ftpPort": "FTP端口",
    "neType": "网元类型",
    "taskId": "任务ID",
    "configEx": "配置导入导出",
    "checkConfigEx": "模板导出",
    "systemSet": "系统设置",
    "centerLatInput": "请输入地图中心的纬度",
    "copyright": "版权信息",
    "batchExport": "批量导出",
    "uploadTipsHeight": "上传图片高度不能超过35像素",
    "rowDataNum": "行数据条数(条)",
    "runOpr": "执行操作",
    "alarmBusManager": "告警业务数据管理",
    "inputUser": "请输入用户名",
    "resultNotice": "结果通知",
    "onlyDel": "删除",
    "userGroupNotNull": "用户组名不能为空",
    "num3000": "3000条",
    "alarmPresent": "告警呈现",
    "uerNameNotNull": "用户名不能为空",
    "hisAlarmData": "历史告警数据",
    "indexLength": "索引长度(M)",
    "systemName": "系统名称",
    "pkgManager": "版本包管理",
    "delTime": "删除时间",
    "addressBook": "通讯录",
    "ftpAddressNotNull": "FTP地址不能为空",
    "taskSearchKey": "输入任务ID或任务名称",
    "confirmDel": "确认删除?",
    "timeRange": "时间范围",
    "createUserInfo": "创建用户信息",
    "backupArea": "备份容量",
    "mailAccount": "邮箱账号",
    "ip": "IP",
    "endDateInvalid": "结束时间应大于开始时间",
    "num10000": "10000条",
    "ftpPortNotNull": "FTP端口号不能为空",
    "CPUUsage": "CPU使用率(%)",
    "dataNameOrFtpPath": "数据名称或FTP路径",
    "loading": "加载中...",
    "isInvalid": "过期",
    "isEffective": "是否生效",
    "acTime": "按时间",
    "userExists": "用户已存在",
    "copyrightInput": "请输入地图版权信息",
    "spectrum": "扫频",
    "reset": "重置",
    "input1t100": "请输入1-100的正整数",
    "backupName": "备份名称",
    "createTask": "创建定时任务",
    "input1t15": "请输入1-15的正整数",
    "lastResult": "最近结果",
    "bothSave": "同时保存",
    "reFault": "失败",
    "sslTlsTip": "SMTP服务器请求SSL/TLS安全连接（请先确认邮箱服务器SSL/TLS证书已安装完成）",
    "save": "保存",
    "uploadText": "上传配置文件",
    "delPkgTip": "确认删除版本包吗?",
    "userCheck": "验证用户名",
    "uploadImgHeight": "35",
    "productEle": "下属网元及平台",
    "mapLatLimit": "请输入合法的纬度,纬度范围 [-90,90]",
    "detailLog": "详细日志",
    "emailQuery": "邮件查询",
    "startTime": "开始时间",
    "sendEmailTime": "邮件发送时间",
    "hourRangeInvalid": "小时间隔应该在1-23内",
    "loginAgain": "请重新登录",
    "timeTaskId": "定时任务id",
    "selectMessages": "请选择数据",
    "analyiseButton": "导入文件",
    "analyiseTxtButton": "导出TXT",
    "delArea": "删除容量",
    "runCyclesTip": "选择执行周期才展示下面区块的表单",
    "change": "修改",
    "updateTime": "更新时间",
    "mapConfig": "地图配置",
    "maxLayer": "最大图层",
    "backupDays": "备份天数",
    "storeDays": "存储天数",
    "storeNumbers": "存储条数",
    "everyWeekend": "每个工作日",
    "uploadSuccess": "上传成功",
    "minLayer": "最小图层",
    "inputTipIp": "请输入IP",
    "busManager": "业务数据管理",
    "oprName": "操作名称",
    "beforeDay30": "30天前",
    "minor": "次要告警",
    "systemMiss": "系统任务",
    "oprArea": "操作容量",
    "sound": "告警声音",
    "uploadSldapPublicKey": "上传LDAP公钥",
    "uploadSldapPublicKeyFail": "上传LDAP公钥失败",
    "uploadSldapPublicKeyDiscribe": "请上传LDAP公钥文件.",
    "uploadKerberosKeytab": "上传 kerberos keytab",
    "uploadKerberosKeytabDiscribe": "请上传 kerberos keytab文件.",
    "ldapServerConfigTip": "提示: 配置系统与ldap服务器的对接参数，建立系统与ldap服务器之间的通信.",
    "usernameFormatIsIncorrect": "用户名只能包含拉丁字母，数字和_, -, . 这三个特殊字符",
    "invalidCerFileType": "无效的文件类型，文件后缀必须是.cer .crt .pem .der .key .jks等格式",
    "invalidKeytabFileType": "无效的文件类型，文件后缀必须是.keytab格式",
    "functionIsUnavailable": "LDAP服务不可用，请联系管理员",
    "uploadTheLdapCertificateFile": "请上传LDAP证书文件",
    "setTheLdapServiceConfigurationAndSaveIt": "请设置Ldap服务配置并保存",
    "authenticationException": "认证失败",
    "usernameError": "用户名错误",
    "passwordError": "密码错误",
    "ldapUrls": "ldap IP地址",
    "ldapUsername": "ldap账户名",
    "ldapPassword": "ldap账户密码",
    "ldapBase": "域名",
    "accountType": "账户类型",
    "UNMAccount": "UNM 账户",
    "LDAPccount": "LDAP 账户",
    "LdapAuthProfile": "LDAP认证配置",
    "LdapAuthProfileBaseDn": "基础DN",
    "LdapAuthProfileAdminBindDn": "Admin绑定DN",
    "LdapAuthProfileAdminBindPassword": "Admin绑定密码",
    "LdapAuthProfileUserSearchDn": "用户搜索DN",
    "LdapAuthProfileUserSearchScope": "用户搜索范围",
    "LdapAuthProfileUserIdAttribute": "用户ID属性",
    "LdapAuthProfileGroupSearchDn": "组搜索DN",
    "LdapAuthProfileGroupSearchScope": "组搜索范围",
    "LdapAuthProfileGroupFilter": "组过滤",
    "LdapAuthProfileGroupMemberAttribute": "组成员属性",
    "LdapAuthProfileSettings": "配置",
    "LdapAuthProfileSearchScope0": "仅搜索指定的对象本身",
    "LdapAuthProfileSearchScope1": "仅搜索指定对象的直接子级",
    "LdapAuthProfileSearchScope2": "搜索指定对象及其所有子级",
    "baseDnTooltip": "BaseDN是搜索的起始点,通常是LDAP目录结构中的根节点",
    "adminBindDnTooltip": "管理员绑定DN是用于绑定到LDAP目录以执行操作的管理员用户的DN.它用于进行身份验证",
    "adminBindPasswordTooltip": "管理员绑定密码是与管理员绑定DN对应的密码,用于验证管理员用户的身份",
    "userSearchDnTooltip": "LDAP用户搜索DN是LDAP目录中搜索给定用户的根.它有助于确保搜索高效,并且仅关注存储用户信息的目录树的相关部分.如果未配置此值，则使用Base DN值.",
    "userSearchScopeTooltip": "LDAP用户搜索范围决定了从用户搜索DN开始的搜索广度.可以设置为以下几种范围:[Base:仅搜索指定的DN、One Level:仅搜索指定DN下的直接子节点、Subtree:搜索指定DN及其所有子节点]",
    "userIdAttributeTooltip": "LDAP用户ID属性是唯一标识单个用户记录的登录属性.",
    "groupSearchDnTooltip": "LDAP组搜索DN是LDAP目录中搜索给定组的根.只有此LDAP目录子树中存在的匹配组才会被检查用户成员身份.",
    "groupSearchScopeTooltip": "LDAP组搜索范围决定了从组搜索DN开始的搜索广度.可以设置为以下几种范围:[Base:仅搜索指定的DN、One Level:仅搜索指定DN下的直接子节点、Subtree:搜索指定DN及其所有子节点]",
    "groupFilteTooltipr": "LDAP组过滤器是用来精确搜索特定组条目的过滤条件,以便只返回符合条件的组.可以在Group Search DN下找到许多不同类型的对象,默认的组过滤器是(objectClass=*)",
    "groupMemberAttributeTooltip": "LDAP组成员属性是一个多值属性,用于存储组成员的DNs.它用于检索关于组成员的数据和管理组成员.",
    "ldapConnectionSecurityMode": "LDAP连接安全模式",
    "ldapConnectionSecurityModeTooltip": "LDAP连接安全模式",
    "ignoreReferrals": "忽略引用",
    "ignoreReferralsTooltip": "启用'忽略群组搜索的引荐'可跳过连接到其他LDAP服务器的引荐链接.默认情况下,此选项处于取消选择状态",
    "enableFullDnForGroupMemberAttribute": "启用组成员属性的完整DN",
    "enableFullDnForGroupMemberAttributeTooltip": "如果组成员条目具有完整的DNs而不是仅仅具有用户ID属性,请启用此选项",
    "LDAP": "LDAP",
    "LDAPS": "LDAPS",
    "portTooltip": "使用LDAPS端口636",
    "port636": "636",
    "port389": "389",
    "groupAccessUNM": "具有访问UNM权限的组名",
    "groupAccessUNMTooltip": "配置具有网管访问权限的组名,支持多个组名的配置,请使用逗号“,”分隔每个组名",
    "ldapAvailabilityTest": "LDAP可用性测试",
    "domainNameTooltip": "配置AD域服务器的域名",
    "saveVerifyTooltip": "Admin Bind DN、User Search DN和Group Search DN包含的dc值必须和Domain name值相同",
    "inputTipEmail": "请输入正确的邮箱地址",
    "DiskUsage": "磁盘使用率(%)",
    "zipTip": "版本包格式不正确",
    "major": "主要告警",
    "inputInteger": "请输入整数",
    "fGroup": "所属用户组",
    "neOAM": "OAM",
    "runTime": "执行时间",
    "day": "天",
    "deactiveTask": "暂停",
    "executeTask":"立即执行",
    "localSave": "本地保存",
    "level": "等级",
    "sendResult": "发送结果",
    "resource": "资源",
    "ftpAddress": "FTP地址",
    "pause": "暂停",
    "tableUncode": "表的字符校验编码集",
    "onlyBackup": "备份",
    "beforeDay15": "15天前",
    "defaultLayer": "默认显示图层",
    "batchImport": "批量导入",
    "checkImport": "上传校验",
    "neConfRestore": "网元配置恢复",
    "restoreSuccess": "网元配置恢复成功",
    "restoreFail": "在恢复过程中检测到异常",
    "customMiss": "自定义任务",
    "missList": "任务列表",
    "enodeb": "eNodeB",
    "no": "否",
    "week": "星期",
    "critical": "严重告警",
    "isReady": "准备就绪",
    "delete": "删除",
    "editGroupInfo": "编辑用户组信息",
    "editTask": "修改任务",
    "fileNotNull": "文件不能为空",
    "hour": "小时",
    "optionalUser": "可选用户",
    "systemNotice": "系统通知",
    "alarm": "告警",
    "selectTimeRange": "请选择时间范围",
    "dataManager": "数据管理",
    "selectFile": "选择文件",
    "select3GPPYysTaskOsType": "请选择3GPP或者自定义任务操作类型",
    "productType": "产品类型",
    "os": "操作系统",
    "invalidIp": "无效的IP地址",
    "emailTitle": "邮件标题",
    "addPkgObj": "请添加适配包",
    "imsOAM": "IMS平台",
    "minute": "分钟",
    "alarmType": "类别",
    "executionInterval": "执行间隔",
    "uploadTipsType": "只能上传png文件",
    "mmlMiss": "MML任务",
    "passwordCheck": "验证密码",
    "centerLat": "地图中心纬度",
    "backupTime": "备份时间",
    "user": "用户",
    "remarks": "备注",
    "3gppMiss":"3GPP任务",
    "backup": "备份",
    "recoveryResult": "恢复结果",
    "generateCfgFile": "生成配置文件",
    "batchInitNECfg": "批量开站",
    "inputNodeIdSection": "请输入节点ID区间进行查找，以'-'分隔",
    "batchInitNECfgCheckSuccess": "模板校验通过，执行结果导出中...",
    "batchInitNECfgCheckFail": "模板校验未通过，请整改参数后重新上传。",
    "executeCMTaskPrompt": "执行此任务会依据数据存储天数补采北向配置上报文件",
    "executeHMTaskPrompt": "执行此任务会依据数据存储天数补采北向资产上报文件",
    "executePMTaskPrompt": "执行此任务会依据数据存储天数补采北向性能上报文件",
    "selectStandardBs": "生成配置数据",
    "standardBsWarning": "请选择标准站",
    "generate": "生成所选基站配置数据",
    "generateAll": "生成全量基站配置数据",
    "standardDes": "生成的配置信息以此页面选择的标准站配置为标准",
    "executeTaskConfirm": "是否立即执行？",
    uploadConfig: {
      uploadConfig: '网元配置反构',
      queryPrompt: '请输入正确格式的查询条件: id或者以分隔符\'-\'分隔的id范围.',
      uploadCurrentPage: '所选eNodeB进行配置反构',
      uploadAll: '对所有在线eNodeB进行配置反构',
      uploadAllPrompt: '您确定对所有在线eNodeB进行配置反构吗？'
    },
  },
  "Profile": {
    "cancel": "取消",
    "pleaseSelectDatas": "请选择数据!",
    "addProfile": "新增用户签约模板",
    "pdnProfileList": "PDN模板",
    "addProfileSuccess": "添加用户签约模板成功",
    "qryProfileSuccess": "查询用户签约模板成功",
    "logger": "日志",
    "delProfileSuccess": "删除用户签约模板成功",
    "profileMaxDl": "最大下行带宽（UE-AMBR/Kbps）",
    "pdnApnName": "接入点名称",
    "zonalCode": "用户漫游区码",
    "selected": "已选择",
    "profileMaxUl": "最大上行带宽（UE-AMBR/Kbps）",
    "add": "增加",
    "nelist": "网元列表",
    "item": "项",
    "failed": "失败",
    "delConfirm": "确定要删除吗？",
    "pleaseSelectOneData": "请选择一条数据!",
    "ntwAccessMode": "入网模式",
    "maxadd": "至多添加",
    "success": "成功",
    "profileId": "用户签约模板ID",
    "items": "项",
    "repeatCode": "存在重复的用户漫游区码",
    "charAt32": "请输入32位以内字符",
    "profileName": "模板名称",
    "repeatMCCMNC": "存在重复的国家码\u0026区域码",
    "chargingChars": "UE计费特性",
    "RelatedProfile": "关联用户签约模板",
    "remove": "删除",
    "zonalCodeObj": "用户漫游区码",
    "crumb": "开户管理/LTE管理/用户签约模板",
    "inquiry": "询问",
    "pleaseSelectNE": "请选择网元",
    "subsPeriodicRauTauTimer": "RAU/TAU定时器（s）",
    "modProfileSuccess": "修改用户签约模板成功",
    "dftPDNProfileID": "默认PDN模板ID",
    "refresh": "刷新",
    "modProfile": "修改用户签约模板",
    "pdnProfileLst": "关联PDN模板ID",
    "pdnProfileId": "关联PDN模板ID",
    "confirm": "确定",
    "modify": "修改",
    "pdnProfileName": "PDN模板名称",
    "minadd": "最少添加",
    "maxadd11": "至多11项",
    "mccMncCode": "国家码\u0026网络码",
    "mccmncObj": "国家码\u0026网络码"
  },
  "Spectrum": {
    "ui_pt_taskrespnull": "扫频结果上报异常，请停止任务，如需继续，请重试！",
    "ui_pt_taskstatus_submit": "提交中",
    "ui_pt_spectrumchoose": "请选择基站和小区！",
    "ui_spectrumphycellid": "物理小区",
    "ui_pt_spectrumave": "平均值",
    "ui_pt_spectrumseconds": "秒",
    "ui_pt_spectrumdelete": "删除",
    "ui_pt_spectrumantdgm": "天线干扰扫描示意图",
    "ui_pt_removespectrumtask": "请选择任务！",
    "6906": "查询扫频数据任务达到上限!",
    "6908": "调用停止任务失败！",
    "ui_pt_spectrum30min": "30 分钟",
    "6907": "扫频任务异常，请停止任务，如需继续，请重试！",
    "ui_pt_spectrumsuspendre": "暂停刷新",
    "6909": "调用删除任务失败！",
    "ui_pt_searchNe": "搜索网元：网元id/网元名称",
    "ui_pt_spectrumbuild": "创建扫频任务",
    "ui_pt_spectrummin": "最小值",
    "ui_pt_taskstatus_execute": "执行中",
    "ui_pt_spectrumNoStop": "未结束",
    "6900": "当前小区存在正在执行的扫频任务，请稍后重试！",
    "6902": "当前状态的任务无法被删除！",
    "6901": "关闭失败，任务已关闭或提交中，请稍后重试！",
    "6903": "无法停止已经结束的任务!",
    "ui_pt_stoptaskfailed": "停止任务失败",
    "ui_pt_taskresperror": "扫频结果上报异常，已停止，如需继续，请重试！",
    "ui_pt_spectrum2s": "2 秒",
    "ui_pt_spectrumadd": "创建",
    "ui_pt_spectrumpeakmon": "峰值监控",
    "spectrum_manager": "扫频管理",
    "ui_pt_spectrumchfindex": "子帧索引",
    "ui_pt_taskstatus_end": "已结束",
    "ui_pt_rbOption": "RB Rssi(单位：dBm)",
    "ui_pt_spectrumcycle": "扫频周期",
    "ui_pt_spectrumdelconform": "确定删除该扫频记录吗？",
    "ui_pt_spectrum1week": "1 周",
    "ui_pt_spectrumcantdelete": "不可删除",
    "ui_pt_spectrum1min": "1 分钟",
    "400": "You cannot delete the picture being used.",
    "401": "You cannot delete system default pictures.",
    "ui_pt_spectrumstopped": "已停止",
    "ui_pt_spectrum10s": "10 秒",
    "402": "The picture has already been deleted.",
    "ui_pt_result": "结果",
    "ui_pt_taskstatus_stop": "停止中",
    "ui_pt_taskstatus_failed": "创建失败",
    "6911": "调用根据时间查询扫频数据任务失败!",
    "ui_pt_spectrum4hour": "4 小时",
    "6910": "调用查询扫频数据任务失败",
    "ui_pt_spectrum10min": "10 分钟",
    "6912": "调用查看扫频记录任务失败!",
    "ui_pt_taskstatus_waiting": "等待中",
    "ui_pt_enodebid": "基站编号",
    "ui_ok": "确定",
    "ui_pt_spectrum1s": "1 秒",
    "ui_pt_spectrumDuration": "持续时间",
    "ui_pt_spectrumunit": "单位",
    "ui_pt_spectrumphycellid": "物理小区标识",
    "NElist": "网元列表",
    "ui_pt_spectrum5min": "5 分钟",
    "ui_pt_spectrumtaskcreate": "创建",
    "ui_oper": "操作",
    "ui_pt_spectrumstop": "停止",
    "ui_pt_spectrumavemon": "均值监控",
    "ui_pt_spectrumfredgm": "时频干扰扫描示意图",
    "ui_pt_neidorname": "网元名ID / 网元名称",
    "ui_pt_spectrumlist": "扫频任务列表",
    "258": "NEs already exist in this segment.",
    "ui_pt_cell": "小区标识",
    "ui_pt_spectrumsectorid": "扇区索引",
    "ui_pt_spectrumtimlin": "时间轴",
    "ui_pt_spectrum1hour": "1 小时",
    "ui_Duration": "期间:",
    "ui_pt_spectrumsca": "频谱扫描",
    "ui_spectrumsectorid": "扇区索引",
    "ui_cell": "小区",
    "ui_pt_starttime": "启动时间",
    "ui_cycle": "周期:",
    "ui_pt_spectrummax": "最大值",
    "ui_pt_spectrumUnit": "单位：(分钟)",
    "ui_pt_endtime": "结束时间",
    "ui_pt_taskstatus": "任务状态",
    "ui_pt_createtaskfailed": "创建任务失败",
    "ui_pt_command": "命令",
    "ui_pt_spectrumexpimg": "导出图片",
    "ui_pt_SpectrumTaskList": "扫频任务列表",
    "ui_cancell": "取消",
    "ui_pt_spectrum5s": "5 秒",
    "ui_pt_spectrum1day": "1 天"
  },
  "UE": {
    "ue_selected": "已选设备",
    "ue_camera_name": "摄像头名称",
    "ue_alias": "UE别名",
    "legend": "图例",
    "ue_sinr2": "SINR2",
    "ue_sinr1": "SINR1",
    "ueSelectDatas": "请选择数据!",
    "select_ue": "选择终端",
    "ue_nrsrp1": "邻区RSRP1",
    "ue_nrsnp2": "邻区RSRP2",
    "ue_state_off": "离线",
    "ue_chart": "订阅UE图表",
    "ue_dl_packet_rate": "下行包率",
    "ue_state_idle": "空闲",
    "ue_select_limit": "最多只能选5个",
    "ue_dl_data": "下行吞吐量",
    "ue_ip": "IP地址",
    "ueConfirm": "确认",
    "neList": "网元列表",
    "ue_base_enodeb": "所属基站别名",
    "ueCancell": "取消",
    "bs_online_count": "基站在线总数:",
    "ue_ul_data": "上行吞吐量",
    "legend_bs": "基站",
    "ue_state_up": "在线",
    "ue_bs_id": "基站ID",
    "ue_camera": "摄像头",
    "ue_rsrp1": "服务小区RSRP1",
    "ue_ul_Traffic": "上行流量",
    "ue_imsi": "IMSI",
    "ue_rsnp2": "服务小区RSRP2",
    "pleaseSelectNe": "请选择网元节点",
    "ue_dl_Traffic": "下行流量",
    "ueDetailData": "详细数据",
    "status": "状态",
    "select_ue_data": "请选择UE",
    "ue_mac": "mac地址",
    "ue_state": "UE 状态",
    "ueSearch": "查询",
    "ue_ul_packet_rate": "上行包率",
    "ue_traffic": "上下行流量",
    "ue_search_imsi": "搜索 IMSI",
    "ueSelectOneData": "请选择一条数据!",
    "latLng": "坐标",
    "ueShowMap": "UE地图",
    "ueManager": "UE管理",
    "ue_bs_name": "基站别名",
    "ue_online_count": "终端在线总数:",
    "legend_ue": "终端",
    "ueTraffic": "UE流量"
  },
  "Monitor": {
    "assetType": "资产类型",
    "localtion": "资产位置",
    "sn": "硬件编码",
    "vid": "厂商编码",
    "Version": "基站设备版本号",
    "assetInfoSync": "资产信息反构",
    "assetSearchPlaceholder": "请输入网元ID或网元名称或资产类型，网元ID可输入范围比如：10-100",
    "hwinfoAsset": "硬件资产",
    "sfpAsset": "光模块资产",
    "assetRadioStatistic": "资产占比统计",
    "assetQuantityStatistics": "资产数量统计",
    "hwinfoAssetTypeStatistic": "硬件资产类型统计",
    "sfpAssetTypeStatistic": "光模块资产类型统计",
    "task": {
      "sampleStart": "开始时间",
      "product": "产品名称",
      "deleteMonitor": "执行中的任务不可删除",
      "deactiveMonitor": "只有执行中的任务可以暂停",
      "activeMonitor": "只有暂停的任务可以执行",
      "oneActiveMonitor": "只能存在一条正在执行的任务",
      "titleName": "系统监控任务",
      "monitoringServiceProcess": "服务进程监控",
      "exeFinish": "执行完毕",
      "sampleEnd": "结束时间",
      "notStarted": "未开始",
      "inUse": "执行中",
      "taskName": "任务名称",
      "CMService": "CM服务",
      "PMService": "PM服务",
      "FMService": "FM服务",
      "exeState": "任务状态"
    },
    "record": {
      "systemInfo": "系统信息",
      "product": "产品",
      "memory": "内存使用率阈值（%）",
      "titleName": "系统监控记录",
      "recoreTime": "记录时间",
      "memoryThreshold": "内存使用率阈值（%）",
      "cpuThreshold": "Cpu使用率阈值（%）",
      "diskSpaceThreshold": "磁盘空间使用率阈值（%）",
      "diskSpace": "磁盘空间使用率阈值（%）",
      "cpu": "Cpu使用率阈值（%）",
      "taskId": "任务id",
      "networkRxRate": "网络接收数据包速率/s",
      "networkTxRate": "网络发送数据包速率/s",
      "IOPSKbRead": "IOPS读取数据量/s",
      "IOPSKbWrite": "IOPS写入数据量/s",
      "queueOperands": "存储队列操作总数/s",
      "databaseDiskSpaceIsUsed": "文件系统中数据库磁盘空间占用大小",
      "snmpAlarmDataSize": "南向告警数量/s",
    },
    "systemLog": {
      "logType": "日志类型",
      "startupSuccess": "启动操作成功，请稍后查看",
      "product": "产品",
      "startupFail": "产品已启动",
      "shutdownFail": "产品已停止",
      "start": "启动日志",
      "run": "运行日志",
      "message": "备注",
      "processInfo": "进程信息",
      "productEnd": "停止时间",
      "systemInfo": "系统信息",
      "titleName": "系统监控日志",
      "recordTime": "记录时间",
      "shutdownSuccess": "停止操作成功，请稍后查看",
      "startup": "启动",
      "productStart": "启动时间",
      "operation": "启动或停止产品",
      "shutdown": "停止"
    },
    "realTimeMonitoring": {
      "crumb": "实时监控",
      "CPUUtilization": "CPU 利用率",
      "memoryTotal": "内存总量",
      "memoryUsage": "内存使用量",
      "memoryUtilization": "内存利用率",
      "diskUsage": "磁盘使用量",
      "diskSize": "磁盘容量",
      "diskUtilization": "磁盘利用率",
    },
    "monitor": "系统监控",
    "placeholder": {
      "sampleStart": "请输入开始时间",
      "product": "请输入产品",
      "sampleEnd": "请输入结束时间",
      "taskName": "请输入系统监控日志"
    },
    "error": {
      "serviceRunning": "服务已运行",
      "serviceStoped": "服务已停止",
      "partOfNeOffline": "部分网元离线",
      "enodebProcessException": "enodeb进程异常",
    }
  },
  "DataManagent": {
    "neid": "网元编号",
    "import": "导入",
    "opType": "操作类型",
    "systemUser": "网管用户",
    "neVersion": "网元版本",
    "distIp": "目标地址",
    "chooseNeidTip": "请先选择网元",
    "chooseDataTip": "请选择数据",
    "fail": "操作失败",
    "opResult": "操作结果",
    "crumb": "开户管理/数据管理",
    "opTime": "操作时间",
    "success": "操作成功",
    "clientIp": "客户端地址",
    "createDataFileFail": "生成数据文件失败",
    "export": "导出",
    "requestTimeOut": "请求超时"
  },
  "PDN": {
    "cancel": "取消",
    "pleaseSelectDatas": "请选择数据!",
    "chargingCharacteristics": "签约APN计费特性",
    "addProfile": "新增模板",
    "apnAMBR_DL": "APN下行AMBR(Kbps)",
    "pgwHostName": "PGW 主机名",
    "addProfileSuccess": "添加PDN模板成功",
    "allowed": "可接入",
    "logger": "日志",
    "qryProfileSuccess": "查询PDN模板成功",
    "pgwAddrLabel": "PGW地址",
    "delProfileSuccess": "删除PDN模板成功",
    "required": "此处不可为空",
    "apnAMBR_UL": "APN上行AMBR(Kbps)",
    "qci": "QCI",
    "arp6": "ARP可被抢占",
    "arp0": "ARP可抢占",
    "selected": "已选择",
    "add": "增加",
    "vplmnAllowed": "漫游地接入",
    "nelist": "网元列表",
    "item": "项",
    "noPreemptable": "不可抢占",
    "arp2_5": "ARP优先级",
    "failed": "失败",
    "preemptedable": "可被抢占",
    "delConfirm": "确定要删除吗？",
    "pleaseSelectOneData": "请选择一条数据!",
    "pgwIpv6Addr": "PGW IPV6地址",
    "profileId": "PDN模板ID",
    "success": "成功",
    "partofpdn": "该值必须是关联PDN模板ID中的一项",
    "pdnType": "PDN类型",
    "profileName": "模板名称",
    "apnName": "接入点名称",
    "pgwIpv4Addr": "PGW IPV4地址",
    "remove": "删除",
    "pgwEnableLabel": "使用签约PGW",
    "pgwHostLabel": "PGW主机",
    "crumb": "开户管理/LTE管理/PDN模板",
    "ipv4": "IPv4",
    "inquiry": "询问",
    "ipv6": "IPv6",
    "pleaseSelectNE": "请选择网元",
    "unallowed": "不可接入",
    "doubleStack": "双栈",
    "modProfileSuccess": "修改PDN模板成功",
    "preemptable": "可抢占",
    "refresh": "刷新",
    "modProfile": "修改模板",
    "confirm": "确定",
    "modify": "修改",
    "noPreemptedable": "不可被抢占",
    "pgwRealmName": "PGW 域名"
  },
  "Plmn": {
    "profileName": "模板名称",
    "addProfile": "新增PLMN模板",
    "mnc": "网络码",
    "amDataProfile": "AM-DATA模板",
    "modProfileSuccess": "修改PLMN模板成功",
    "addProfileSuccess": "添加PLMN模板成功",
    "amDataProfileId": "关联AM-DATA模板ID",
    "qryProfileSuccess": "查询PLMN模板成功",
    "amDataProfileName": "AM-DATA模板名称",
    "modProfile": "修改PLMN模板",
    "mcc": "国家码",
    "delProfileSuccess": "删除PLMN模板成功",
    "snssaiProfileId": "关联网络切片模板ID",
    "snssaiProfileIds": "关联网络切片模板",
    "crumb": "开户管理/UDM管理/PLMN模板",
    "profileId": "PLMN模板ID",
    "amDataProfileIds": "关联AM-DATA模板",
    "snssaiProfile": "网络切片模板",
    "snssaiProfileName": "网络切片模板名称"
  },
  "Supi": {
    "modProfileSuccess": "修改用户成功",
    "addProfileSuccess": "添加用户成功",
    "exceedGpsi": "批量开户数据中存在GPSI大于15位的数据",
    "qryProfileSuccess": "查询用户成功",
    "supi": "SUPI",
    "delProfileSuccess": "删除用户成功",
    "gpsi": "GPSI",
    "ipv6Addr": "静态IPV6地址",
    "crumb": "开户管理/UDM管理/用户管理",
    "character15": "5~15字符",
    "supiSearch": "输入SUPI号进行查询",
    "exceedSupi": "批量开户数据中存在SUPI大于15位的数据",
    "userSubProfileId": "关联用户签约模板",
    "ipv4Addr": "静态IPV4地址",
    "supiRange": "SUPI范围"
  },
  "AmData": {
    "RFSPindex": "RFSP索引",
    "profileName": "模板名称",
    "addProfile": "新增AM-DATA模板",
    "addProfileSuccess": "添加AM-DATA模板成功",
    "qryProfileSuccess": "查询AM-DATA模板成功",
    "ueAmbrDown": "最大下行带宽(UE-AMBR/Kbps)",
    "edrx": "Edrx参数表",
    "areaType3": "禁止区域",
    "areaType2": "非允许区域",
    "delProfileSuccess": "删除AM-DATA模板成功",
    "areaType1": "允许区域",
    "RatType": "限制接入类型",
    "crumb": "开户管理/UDM管理/AM-DATA模板",
    "allowAreaType": "业务区域限制类型",
    "areaType": "区域类型",
    "tac": "跟踪区域码",
    "mico1": "不允许",
    "mico0": "允许",
    "notAllowOne": "不允许只填写一个",
    "areaTypeNotNull": "此情况区域类型需选择",
    "modProfileSuccess": "修改AM-DATA模板成功",
    "areaForbid": "业务区域限制",
    "edrxValue": "edrx值",
    "ratType": "限制类型",
    "modProfile": "修改AM-DATA模板",
    "areaCode": "区域码",
    "profileId": "AM-DATA模板ID",
    "forbidAreaCode": "禁止区域区域码",
    "forbidTac": "禁止区域跟踪区域码",
    "ueAmbrUp": "最大上行带宽(UE-AMBR/Kbps)",
    "conflict": "区域类型冲突",
    "micoAllowed": "MICO模式"
  },
  "Pm": {
    "exportCustomKPI": "导出自定义KPI",
    "exportTemplate": "导出模板",
    "cancel": "取消",
    "thresholdSettingFail": "阈值设置失败",
    "taskDespOver256": "任务描述不能大于256字符",
    "neOffline": "网元不在线",
    "atLeastOne": "请选择至少一条记录",
    "editTemplate": "模板编辑",
    "importantAlarmUpperMore": "重要告警阈值上限值必须高于阈值下限值",
    "taskDescription": "任务描述",
    "del": "删除",
    "addReportTask": "添加报表任务",
    "secondaryAlarmUpperMore": "次要告警阈值上限值必须高于阈值下限值",
    "taskState": "任务状态",
    "notCloseHome": "禁止关闭首页",
    "consistencyQuery": "一致性状态查询",
    "checkUniformity": "一致性检查",
    "updateReportTask": "修改报表任务",
    "importantAlarm": "重要告警",
    "taskStatus": "任务状态",
    "secondaryAlarmLowerNoInclude": "次要告警下限值（不包含）",
    "disableTask": "关闭任务",
    "selectResourcePlease": "请选择合适的资源",
    "active": "激活",
    "measureObjectTypeCode": "测量对象类型编号",
    "gnbPmDataQuery": "性能数据查询",
    "unknownError": "未知错误",
    "pmReportManagement": "性能报表管理",
    "counterCreateTime": "指标创建时间",
    "realtime_task_createTask": "创建实时测量任务",
    "byIndicator": "按指标",
    "syncTime": "同步时间",
    "addToFollow": "加入下侧",
    "taskList": "任务列表",
    "mostNineCounterCanView": "最多只能查看9个指标",
    "notInputSpace": "不允许输入空格",
    "endTimeFrame": "结束时段",
    "oneHour": "1小时",
    "delTask": "删除任务",
    "search": "搜索",
    "taskNameOver60": "任务名称不能大于60字符",
    "failedToStart": "启动任务失败",
    "modCustomCounter": "修改自定义指标",
    "selectDataPlease": "请选择数据",
    "wednesday": "周三",
    "pleaseInput": "请输入",
    "emergencyAlarmUpperInclude": "紧急告警上限值（包含）",
    "uploadBeginTime": "补采起始时间",
    "thresholdUpdateSuccess": "阈值更新成功",
    "thursday": "周四",
    "thresholdEmptyDelete": "阈值全部为空，已经设置的阈值将被删除，是否执行？",
    "counterSpace": "空间粒度",
    "deleteSuccessfully": "删除成功",
    "startUp": "启动",
    "delCustomCounter": "删除自定义指标",
    "days": "天",
    "reportTaskLogTile": "报表任务日志",
    "promptAlarmUpperInclude": "提示告警上限值（包含）",
    "activeTask": "激活任务",
    "resourceOffline": "资源不在线",
    "pmManagement": "性能管理",
    "endNoEarilerThanCurrent": "结束时间不能早于当前时间",
    "nonReal": "非实时",
    "editTime": "编辑时间",
    "promptAlarm": "提示告警",
    "emergencyAlarm": "紧急告警",
    "pauseTime": "暂停时间",
    "inputSearhString": "请输入查询条件",
    "finish": "完成",
    "export": "导出",
    "info": "信息",
    "defaultPermanent": "默认为永久",
    "add": "添加",
    "counterFormula": "指标公式",
    "defaultNow": "默认为当前时间",
    "ne_name": "资源名称",
    "dataType": "数据类型",
    "samplingPeriod_unit": "采样周期(s)",
    "thresholdAlarm": "门限告警",
    "alertInvalidTime": "激活状态下，失效时间不能早于当前时间",
    "onlyNumAndLetter": "只能填写数字和英文字母",
    "allAlarm": "全部告警",
    "integrityCheck": "完整性检查",
    "success": "成功",
    "emergencyAlarmLowerNoInclude": "紧急告警下限值（不包含）",
    "nextStep": "下一步",
    "oneMinute": "1分钟",
    "resourcePort": "资源端口",
    "frame": "框号",
    "reportTaskLog": {
      "all": "全部",
      "statusFail": "失败",
      "statusSuccess": "成功",
      "message": "备注",
      "exeTime": "执行时间",
      "status": "执行状态"
    },
    "createPmTask": "创建任务",
    "neLatest": "网元最新",
    "counterUnit": "指标单位",
    "pleaseSelectCounter": "请选择指标",
    "pleaseInputInteger": "请输入整数",
    "selectNe": "选择网元",
    "promptAlarmUpperAndLowerAllNeed": "提示告警阈值上限和阈值下限不能只设置一个",
    "measurementObjectClassify": "测量对象分类",
    "alertHeader": "警告",
    "kpiChartEdit": "KPI图表配置",
    "secondaryAlarmUpperAndLowerAllNeed": "次要告警阈值上限和阈值下限不能只设置一个",
    "resourceList": "资源列表",
    "pcs": "个",
    "timeShouldEarlierThanCurrent": "补采结束时间应早于当前时间",
    "showTemplate": "查询报表模板",
    "custom": "自定义",
    "pmAlarmManagement": "性能告警管理",
    "noSetting": "不设置",
    "customCounter": "自定义指标",
    "oneDay": "1天",
    "modify": "修改",
    "dataLatest": "数据最新",
    "preStep": "上一步",
    "processCode": "进程号",
    "bySeat": "按位置",
    "deleteTask": "删除任务",
    "neType": "网元类型",
    "uploadAlarm": "补采告警",
    "thresholdActiveStatus": "门限激活状态",
    "taskTimeRemaining_unit": "任务剩余时间(s)",
    "measuringPosition": "测量位置",
    "paramType": "性能参数类型",
    "number": "个",
    "inactive": "去激活",
    "searchByName": "根据名称搜索",
    "statistic_cycle": "统计周期(s)",
    "taskNameNull": "任务名称不能为空",
    "indicatorFormulaColumn": "指标公式",
    "exportChart": "导出图片",
    "saveDataOrNot": "是否保存数据",
    "counterVal": "指标值",
    "alertData1": "请选择一条数据",
    "pleaseSelectUploadBeginTime": "请选择补采起始时间",
    "ip": "IP",
    "realTime": "实时",
    "kpiChartAnalyz": "性能图表分析",
    "system": "系统",
    "indicatorDesc": "指标描述",
    "indicatorState": "指标状态",
    "samplingPeriod": "采样周期",
    "customCounterList": "自定义指标列表",
    "showMeasureCustom": "查看自定义测量指标",
    "uniformityState": "一致性检查",
    "createTask": "创建/修改任务",
    "reportTime": "上报时间",
    "indicatorName": "指标名称",
    "selectResource": "选择资源",
    "counterParamType": "参数类型",
    "taskDuration_unit": "任务时长(s)",
    "counterTypeId": "测量对象编号",
    "reportTaskTile": "报表任务",
    "selectedKpiPath": "已选择的KPI指标路径",
    "selectIndicator": "选择指标",
    "monday": "周一",
    "selectNePlease": "请选择合适的网元",
    "end_time": "结束时间",
    "modifyTask": "修改任务",
    "ascending": "升序",
    "thresholdDetail": "门限详情",
    "inconsistent": "不一致",
    "enableTask": "开启任务",
    "disable": "关闭",
    "templateCreatePeople": "模板创建人",
    "realOrNo": "实时/非实时",
    "complete": "完成",
    "noPlan": "无计划",
    "resourceType": "资源类型",
    "searchNe": "搜索网元",
    "uploadBaseTimeError": "补采基准时间格式错误",
    "alertInvalidDate": "请输入有效的日期",
    "measureCustom": "自定义测量指标",
    "hangup": "挂起",
    "second": "第二步",
    "mode": "模式",
    "pmTaskManagement": "性能任务管理",
    "oClock": "时",
    "pleaseSelectSpaceNode": "请选择空间粒度节点",
    "dataCollection": "数据采集",
    "all": "全部",
    "importantAlarmUpperInclude": "重要告警上限值（包含）",
    "alertFormula3": "公式中的指标与测量对象不匹配",
    "alertFormula2": "公式中没有指标",
    "ms": "毫秒",
    "alertFormula4": "公式长度超过512个字符",
    "kbps": "千比特/秒",
    "multiInstanceChartStatistics": "多实例图表统计",
    "hangUpStartTime": "挂起开始时间",
    "alertFormula1": "指标公式不能为空",
    "real": "实时",
    "samplingStartTime": "采集开始时间",
    "secondaryAlarm": "次要告警",
    "doubleClickChoose": "双击选择指标",
    "statusSetting": "状态设置",
    "addMonitorTask": "新增系统监控任务",
    "unit": "单位",
    "thirtyMinutes": "30分钟",
    "chooseObject": "选择测量对象",
    "ne": "网元",
    "resultEmpty": "查询结果无数据",
    "pleaseSelectMeasureObj": "请选择测量对象",
    "no": "否",
    "hasSameIndicatorName": "已有相同名称指标！",
    "slot": "槽号",
    "switch": "转换",
    "times": "次",
    "counterList": "指标列表",
    "today": "今天",
    "dataMining": "数据补采",
    "friday": "周五",
    "activeThreshold": "激活门限",
    "queryInfo": "数据查询",
    "oneMonth": "1月",
    "determine": "确定",
    "delTemplate": "删除模板",
    "alertRequired": "该项不能为空",
    "reportTemplate": "报表模板",
    "establishTask": "创建任务",
    "massEstablishTask": "批量创建任务",
    "massEstablishTaskTotal": "任务总条数",
    "massEstablishTaskSuccess": "任务成功条数",
    "massEstablishTaskError": "任务失败条数",
    "massEstablishTaskErrorDetail": "失败详情",
    "cellMeasure": "小区测量",
    "alarmType": "告警类型",
    "thresholdSetStatus": "门限设置状态",
    "waitCommandFinish": "请等待命令执行完毕",
    "chooseCounters": "选择指标",
    "indicatorAndThreshold": "指标与阈值管理",
    "singleInstanceChartStatistics": "单实例图表统计",
    "systemTemplate": "系统模板",
    "selectIndicatorPlease": "请选择指标！",
    "selectIndicatorCannotCross": "选择的指标不能跨测量对象！",
    "ne_type_id": "资源类型",
    "resourceId": "资源编码",
    "taskUploadSetting": "任务补采设置",
    "hasSameTaskName": "已有相同名称任务！",
    "templateUpdateTime": "模板更新时间",
    "measureCycle": "测量周期",
    "measureCycleTips": "基站上报数据的周期为15分钟，UNM在查询和导出数据时可以选择周期粒度.",
    "upperUnlimited": "最高无限制",
    "pmDataLineChart": "性能数据折线图",
    "assocId": "偶联ID",
    "cellId": "小区ID",
    "enodebId": "基站ID",
    "beyondTheScope": "超出范围",
    "reportTaskDetailed": "报表任务详情",
    "resourceIp": "资源ip",
    "taskID": "任务编码",
    "failedToCreate": "创建任务失败",
    "resourceVersion": "资源版本",
    "customTemplate": "自定义模板",
    "realTimeByIndicator": "实时测量任务（按指标）",
    "taskName": "任务名称",
    "timeMode": "时间模式",
    "oneWeek": "1周",
    "reportGnbData": "报表数据",
    "saturday": "周六",
    "measurePlan": "测量计划",
    "subnetWork": "子网节点",
    "invalidTime": "失效时间",
    "emergencyAlarmUpperMore": "紧急告警阈值上限值必须高于阈值下限值",
    "performanceIndicatorManage": "性能指标管理",
    "alarmLevel": "告警级别",
    "latest": "最新",
    "cycleMeasurement": "周期测量",
    "Intodb_time": "数据入库时间",
    "begTimeFormatError": "开始时间格式不对",
    "confirm": "确认",
    "twentyMinutes": "20分钟",
    "sortMethod": "排序方式",
    "consistentState": "一致性状态",
    "secondaryAlarmUpperInclude": "次要告警上限值（包含）",
    "promptAlarmUpperMore": "提示告警阈值上限值必须高于阈值下限值",
    "endTime": "结束时间",
    "resource_name": "资源名称",
    "systemCounterList": "系统指标列表",
    "cabinet": "柜号",
    "measurementObject": "测量对象",

    "createTaskUser": "创建任务用户",
    "notSet": "未设置",
    "syncTask": "同步任务",
    "begTimeNull": "开始时间不能为空",
    "queryWillDel": "确认删除",
    "templateCreateTime": "模板创建时间",
    "measureObj": "测量对象",
    "plmn":"公共陆地移动网络编码",
    "scell_id":"源小区",
    "dcell_id":"目的小区",
    "splmn":"源公共陆地移动网络编码",
    "dplmn":"目的公共陆地移动网络编码",
    "cell_id": "小区编码",
    "cell_name": "小区别名",
    "ne_id": "资源ID",
    "fiveMinutes": "5分钟",
    "importantAlarmUpperAndLowerAllNeed": "重要告警阈值上限和阈值下限不能只设置一个",
    "customCounterTypeId": "自定义测量指标编号",
    "uploadTask": "补采任务",
    "query": "查询",
    "multiResourceChart": "多资源维度图表",
    "resourceName": "资源名称",
    "sysTemplateNoEdit": "系统模板不可编辑",
    "measureObjName": "测量对象名称",
    "emergencyAlarmUpperAndLowerAllNeed": "紧急告警阈值上限和阈值下限不能只设置一个",
    "synchronousDownload": "同步下载",
    "collectCycle": "测量周期",
    "lastWeek": "上周",
    "hangupThreshold": "挂起门限",
    "start_time": "开始时间",
    "templateAddTask": "模板添加任务",
    "realTimeMeasurement": "实时测量",
    "failure": "失效",
    "name": "名称",
    "deleteFailed": "删除失败",
    "next": "下一步",
    "periodTime": "时段",
    "taskInProgress": "任务正在执行...",
    "revoke": "撤销",
    "description": "描述",
    "systemCounter": "系统指标",
    "thresholdSetting": "门限设置",
    "yesterday": "昨天",
    "pleaseSelectResource": "请选择资源节点",
    "thresholdExistUpdateOrNot": "阈值设置已经存在，是否更新？",
    "counterTypeName": "测量对象名称",
    "currentWeek": "本周",
    "placeholder": {
      "exeCycle": "请输入执行周期",
      "parameterType": "请输入性能参数类型",
      "name": "请输入任务名称",
      "customs": "请输入指标列表",
      "format": "请输入报表生成格式",
      "startTime": "请输入任务开始时间",
      "endTime": "请输入任务结束时间",
      "neType": "请输入网元类型",
      "space": "请输入空间粒度",
      "exeStep": "请输入任务执行天数"
    },
    "counterCreatePeople": "指标创建人",
    "hangUpEndTime": "挂起结束时间",
    "gnbManagement": "gnb性能管理",
    "hours": "小时",
    "previous": "上一步",
    "yes": "是",
    "task_opened": "新建任务之前请关闭已经打开的标签窗口",
    "selectMOplease": "请选择测量对象！",
    "managedElement": "网元节点",
    "realTimeBySeat": "实时任务测量（按位置）",
    "templateType": "模板类型",
    "batchExport": "批量导出",
    "counterManagement": "指标管理",
    "endCannotLaterThanTaskEnd": "补采结束时间不能晚于任务结束时间",
    "homePage": "首页",
    "seconds": "秒",
    "addTemplate": "添加模板",
    "enable": "开启",
    "timeRange": "时间范围",
    "calculator": "计数器",
    "atMostOneRealTask": "最多只能建立一个实时任务并且同时只能打开一个任务标签页",
    "queryScope": "查询范围",
    "taskTimeRemaining": "任务剩余时间",
    "activeTime": "激活时间",
    "fail": "失败",
    "sunday": "周日",
    "successInfo": "操作成功",
    "fifteenMinutes": "15分钟",
    "longTime": "长期",
    "indicatorList": "指标列表",
    "measureTaskManagement": "测量任务管理",
    "pleaseSelectNe": "请选择资源",
    "thresholdHasSet": "阈值已设置",
    "reset": "重置",
    "performTask": "执行任务",
    "updateMonitorTask": "修改系统监控任务",
    "chooseCycle": "选择测量周期",
    "monthPlan": "月测量计划",
    "specified": "指定",
    "addMeasureCustom": "添加自定义测量指标",
    "alertIsNumberHeader": "不能以数字、空格开头",
    "hangUpTask": "挂起任务",
    "startCannotLaterThanEnd": "开始时间不能晚于结束时间",
    "thresholdNotSet": "阈值未设置",
    "alarmCreateTime": "告警产生时间",
    "counterNameEN": "指标英文名称",
    "startTime": "开始时间",
    "editor": "编辑人",
    "nonRealTime": "非实时",
    "addThreshold": "添加阈值",
    "uploadBeginTimeError": "补采起始时间格式错误",
    "endTimeNull": "结束时间不能为空",
    "consistent": "一致",
    "counterCode": "指标编码",
    "pleaseInputAlias": "请填写别名",
    "quickExport": "快捷导出",
    "fillCorrectTaskDuration": "请填写正确任务时长！",
    "first": "第一步",
    "indicator": "指标",
    "indicatorIsOccupied": "指标被占用，无法创建新任务",
    "multiMeasureObjChart": "多测量对象维度图表",
    "measObjLdn": "空间参数粒度",
    "kilobit": "1000bit",
    "counterNameCH": "指标中文名称",
    "taskAlreadyExists": "任务已存在",
    "enodeb_id": "基站编码",
    "threshold": "阈值管理",
    "descending": "降序",
    "startNoLagerThanEnd": "起始时间不能晚于结束时间",
    "thresholdSettingSuccess": "阈值设置成功",
    "queryDetailInfo": "详细信息查询",
    "resource": "资源",
    "alertMaxLength": "文字长度不能超过",
    "minutes": "分钟",
    "kpiChartShow": "KPI图表展示",
    "data_bilievable": "数据完整性",
    "searchByNe": "根据网元名称搜索",
    "sysTemplateNoDel": "系统模板不可删除",
    "counterUpdateTime": "指标更新时间",
    "pause": "暂停",
    "dbm": "毫瓦分贝",
    "endTimeFormatError": "结束时间格式不对",
    "importantAlarmLowerNoInclude": "重要告警下限值（不包含）",
    "tenMinutes": "10分钟",
    "pleaseSelectUploadBaseTime": "请选择补采基准时间",
    "customCounterTypeName": "自定义测量指标名称",
    "startCannotEarlierThanTaskStart": "补采开始时间不能早于任务开始时间",
    "reportTask": {
      "taskLog": "报表任务执行记录",
      "parameterType": "性能参数类型",
      "hours": "小时",
      "months": "月",
      "weeks": "周",
      "exeTaskSuccess": "手工触发任务成功，请到报表页面查询。",
      "exeTask": "手工触发任务",
      "format": "报表生成格式",
      "fixedDays": "固定天数",
      "exeTime": "任务统计截止时间",
      "space": "空间粒度",
      "exeStep": "务执行天数",
      "exeCycle": "执行周期",
      "name": "任务名称",
      "customs": "指标列表",
      "days": "日",
      "startTime": "任务开始时间",
      "endTime": "任务结束时间",
      "neType": "网元类型"
    },
    "uploadBaseTime": "采集基准时间",
    "counterName": "指标名称",
    "measureObjectTypeName": "测量对象类型名称",
    "noRealTaskManagement": "非实时任务管理",
    "noRealTaskTemplateManagement": "非实时任务模板管理",
    "addCustomCounter": "新增自定义指标",
    "alarmKpi9": "九宫格最多只能显示9个KPI指标",
    "multiResourceChartQuery": "多资源图表查询",
    "lowUnlimited": "最低无限制",
    "reportCycle": "上报周期",
    "indicatorFormulaText": "指标公式(运算显示区)",
    "noRealDataQuery": "非实时数据查询",
    "alias": "别名",
    "weekPlan": "周测量计划",
    "fillInSamplingPeriod": "请填写采样周期！",
    "hangupTime": "挂起时间",
    "exitTaskInfo": "已有任务信息",
    "taskDuration": "任务时长",
    "measureTask": "任务测量",
    "thresholdCanNotAllEmpty": "阈值不能全部为空",
    "clear": "清除",
    "promptAlarmLowerNoInclude": "提示告警下限值（不包含）",
    "uniformityCheckTime": "一致性检查时间",
    "toastHeader": "提示",
    "startTimeFrame": "开始时段",
    "indicatorID": "指标ID",
    "taskEstablishTime": "任务创建时间",
    "tuesday": "周二",
    "templateName": "模板名称",
    "selectMSeatPlease": "请选择测量位置！",
    "task_started": "当前客户端已订制该任务",
    "check_customMeasureId_tips": "当前指标已经被下列任务引用,需要删除任务后再删除指标:",
    "deleteNoRealTaskWarningTips" : "确认删除所选的性能任务吗，删除性能任务后会同步删除该网元的性能数据？",
    "targetErrorValue" : "异常值",
    "calculateKpi" : "计算kpi",
    "taskTemplate":{
      "tmplId": "模板ID",
      "tmplName": "模板名称",
      "neType": "网元类型",
      "neVersion": "资源版本",
      "measureCycle": "测量周期",
      "taskNameRule": "任务名称规则",
      "taskNamePrefix": "任务名称前缀",
      "tmplDepict": "任务描述",
      "tmplStatus": "模板状态",
      "tmplEditTime": "模板编辑时间",
      "tmplEditPeople": "模板编辑人",
      "initMeterStatus": "初始任务状态",
      "effectiveTimeMode": "时间模式",
      "meterBegTime": "任务起始时间",
      "meterEndTime": "任务失效时间",
      "baseStationName": "网元名称",
      "baseStationId": "网元ID",
      "baseStationIpPlusPort": "网元IP+端口",
      "selectedTmplEnable": "确定要启用所选记录？",
      "selectedTmplDisable": "确定要禁用所选记录？",
      "createTaskTemplate": "创建任务模板",
      "updateTaskTemplate": "编辑任务模板",
      "showTaskTemplate": "查看任务模板",
      "taskTemplateTitle": "任务模板",
      "delTaskTemplate": "删除任务模板",
    },
  },
  "subscriber": {
    "epcDelProfile": "删除配置文件"
  },
  "MR": {
    "deleteTaskSuccess": "任务删除成功",
    "neName": "资源名称",
    "deleteTaskToorBar": "删除任务",
    "samplePeriod": "MR采样周期",
    "neIp": "资源IP",
    "neVersion": "资源版本",
    "uploadPeriod": "MR采集周期",
    "prbNum": "子帧PRB",
    "enableTaskToorBar": "开启任务",
    "enable": "开启",
    "pleaseSelectNE": "请选择网元",
    "alias": "别名",
    "addTaskSuccess": "任务创建成功",
    "omcName": "OMC-R名称",
    "mrTaskManage": "MR测量任务管理",
    "sampleBeginTime": "开始时间",
    "noNull": "该项不能为空",
    "disableTaskToorBar": "禁用任务",
    "measureType": "MR文件类型",
    "timeFormatError": "基准时间格式错误",
    "addMrTask": "MR测量任务新增",
    "sampleEndTime": "结束时间",
    "nePort": "资源端口",
    "addTaskToorBar": "新增任务",
    "subFrameNum": "子帧数",
    "disable": "关闭",
    "setTaskStatusSuccess": "任务状态设置成功",
    "mrManage": "MR管理",
    "enableStatus": "任务状态"
  },
  "Pui": {
    "addPuiSuccess": "添加PUI成功",
    "pui": "PUI",
    "delPuiSuccess": "删除PUI成功",
    "authType2": "激活",
    "forbidType1": "限制全部隐私信息",
    "cfnlStatus": "未注册前转签约状态",
    "forbidType0": "限制特定标识",
    "puiList": "签约关联",
    "oirTemporarySet": "主叫号码禁显默认设置",
    "authType0": "未授权",
    "authType1": "授权",
    "addPui": "新增PUI",
    "oipStatus": "主叫号码显示签约状态",
    "cfnrStatus": "无应答前转签约状态",
    "cfuStatus": "无条件前转签约状态",
    "cfbPui": "遇忙前转号码",
    "pvi": "PVI",
    "cfnrTime": "无应答时间",
    "modPuiSuccess": "修改PUI成功",
    "cfbPuiNull": "遇忙前转号码为空",
    "oirStatus": "主叫号码禁显签约状态",
    "cfnlPuiNull": "未注册前转号码为空",
    "cfnrPuiNull": "无应答前转号码为空",
    "modeType1": "临时模式",
    "holdStatus": "呼叫保持签约状态",
    "cfnlPui": "未注册前转号码",
    "ocbStatus": "禁止呼出签约状态",
    "cfbStatus": "遇忙前转签约状态",
    "modeType0": "固定模式",
    "oirRestrictMode": "主叫号码禁显限制处理",
    "cfuPuiNull": "无条件前转号码为空",
    "cfnrPui": "无应答前转号码",
    "oipOverried": "主叫号码显示覆盖",
    "cwStatus": "呼叫等待签约状态",
    "showType0": "默认显示不限制",
    "showType1": "默认显示限制",
    "thirdPartyStatus": "三方呼叫签约状态",
    "crumb": "开户管理/VONR管理/PUI",
    "addBatchPui": "批量新增PUI",
    "cwNotify": "呼叫等待是否通知被叫",
    "icbStatus": "禁止呼入签约状态",
    "cwNotifyType1": "不通知",
    "modPui": "修改PUI",
    "puiSearch": "输入PUI进行查询",
    "cwNotifyType0": "通知",
    "oirMode": "主叫号码禁显模式",
    "cfuPui": "无条件前转号码",
    "cfnrcPui": "不可及前转号码",
    "cfnrcStatus": "不可及前转签约状态",
    "confStatus": "电话会议签约状态",
    "qryPuiSuccess": "查询PUI成功"
  },
  "Snssai": {
    "profileName": "模板名称",
    "dnnProfileList": "DNN模板",
    "addProfile": "新增网络切片模板",
    "modProfileSuccess": "修改网络切片模板成功",
    "dnnProfile": "关联DNN模板ID",
    "addProfileSuccess": "添加网络切片模板成功",
    "qryProfileSuccess": "查询网络切片模板成功",
    "modProfile": "修改网络切片模板",
    "delProfileSuccess": "删除网络切片模板成功",
    "sd": "SD",
    "dnnProfileName": "DNN名称",
    "crumb": "开户管理/UDM管理/网络切片模板",
    "sst": "SST",
    "profileId": "网络切片模板ID"
  },
  "Login": {
    "copyright": "软件使用许可协议",
    "kaptcha": "验证码",
    "footer": {
      "copyright": "推荐使用谷歌浏览器71以上版本，分辨率1920*1080"
    },
    "firstLogin": "首次登录,请修改密码",
    "title": "综合网络管理系统",
    "login": "登录",
    "uploadListLicense": "批量上传license",
    "updPasswdTitle": "修改密码",
    "license": "License",
    "password": "密码",
    "kaptchaError": "验证码加载错误",
    "failure": "失败",
    "uploadLicense": "上传license",
    "Iplimit": "客户端访问受限",
    "pwdExpired": "密码已过期",
    "loginExpired": "由于长时间未登录系统，此账号已被锁定，请联系管理员进行解锁。",
    "unlock": "解锁",
    "unlocked": "此账号超时状态为正常，无需解锁。",
    "forceLoginTitle": "登录提示",
    "copyrightInfo": {
      "line13": "不得分发或转让：未经海能达公司授权，不得出售、分发、租赁、出租、发放子许可、让渡或转让本软件的权利，或者复制本软件。",
      "line14": "1.5 管辖法律",
      "line11": "不得用于非设计用途：不得以不符合本软件设计的方式来安装或使用本软件，包括规避内容保护技术，以及在非设计用于运行和使用本软件的计算机上使用本软件。",
      "line12": "不得进行逆向工程：不得对有关软件的源代码进行逆向工程、反编译或试图以其他方式发现软件的源代码。",
      "line10": "不得修改：不得在非授权情况下修改、翻译或改编本软件，或基于本软件创作衍生作品。",
      "line19": "在您所在地的相关法律允许的情况下，上述限制和排除方可适用。本责任限制在某些国家可能无效，在此情况下，您可能依据消费者保护法和其他法律享有其他不得放弃的权利。",
      "line3": "本协议中“软件”是指所有海能达通信股份有限公司（以下简称“海能达公司”）提供给使用方的源代码、可执行代码、程序、接口、文档、数据库、数据、图片、声音、标志和标识等，包括但不限于(i)计算机源代码、可执行代码、接口程序；(ii)有关文档和文件；(iii) 提供的升级版本、软件的补丁；(iV)使用的数据库和数据。",
      "line17": "本软件产品以现状方式提供，海能达公司不保证本软件产品能够或不能够完全满足用户需求，在用户手册、帮助文件、使用说明书等软件文档中的介绍性内容仅供用户参考，不得理解为对用户所做的任何承诺。",
      "line2": "1.1 定义",
      "line18": "在相关法律所允许的最大范围内，由您使用或不能使用本软件产品(包括但不限于营业利益的损失，营业中断，商业信息遗失，数据或代码损坏，程序运行出错、第三方知识产权追责)而造成损害的，您需独立承担相关损失并给对海能达或海能达供应商造成的损害作出补偿。",
      "line1": "用户须知：请先仔细阅读本软件使用许可协议(以下简称“协议”)再使用本软件或本软件未来的更新，一经使用本软件或任何更新即表示您同意并接受本许可证的条款约束。如果您不同意本许可证的条款，请勿安装或使用本软件产品。",
      "line15": "本协议受中华人民共和国法律管辖。因本协议或其违约引起的或与之有关的任何争论或索赔，应由海能达公司所在地的有管辖权的法院管辖。海能达公司的知识产权如被侵犯，上述规定不限制海能达公司就此向具有合法管辖权的法院请求对您发出强制性的补救令。",
      "line16": "1.6 责任限制",
      "line7": "1.3 软件许可",
      "line6": "本软件可能会使用第三方软件或技术（包括本软件可能使用的开源代码和公共领域代码等。本软件如果使用了第三方的软件或技术，海能达将按照相关法规或约定，对相关的协议或其他文件，可能通过本协议附件、在本软件安装包特定文件夹中打包、或通过开源软件页面等形式进行展示。本软件所使用的第三方软件或技术，相关产权、版权及其它知识产权归原开发方所有。",
      "line5": "海能达公司拥有本软件的产权、版权和其它知识产权。本软件受版权和其它知识产权法律及条约的保护。“Hytera”、“HYT”和“海能达”为海能达公司在中华人民共和国和世界其他国家和/或地区的商标或注册商标。海能达公司仅对自有商标、产品名称、独自开发代码等知识产权享有所有权。海能达公司保留未在此协议中明示授予您的一切权利。",
      "line4": "1.2 知识产权",
      "line9": "1.4 使用限制",
      "line8": "您需要获取海能达或经海能达认可的第三方的授权许可并缴纳相关软件使用许可费或其他费用后，方可合法使用本软件。本软件只能用于海能达公司的产品和服务上，且只能以海能达或经海能达认可的第三方明示许可的方式在被许可的对象、范围、数量、期限、版本内使用。任何将本软件使用于与海能达公司无关的产品和服务，或者超出海能达或经海能达认可的第三方的许可限制进行使用的行为，都是被禁止的。如您违反或不同意本协议下任何条款，您取得软件使用许可及相关权利将自动终止。海能达保留对任何人非法使用本软件的追责权利。",
      "line24": "1.9 其他",
      "line25": "本协议不损害任何一方作为消费者的合法权益。本协议的修改须经海能达公司授权人员书面签署后方能生效。本协议是海能达公司与您之间有关本软件的完整协议，它将取代先前任何与本软件相关的陈述、讨论、承诺、通信或宣传。",
      "line22": "1.8 协议终止",
      "line23": "如果您未遵守本协议的各项条款和条件，在不损害其它权利的情况下，海能达公司可随时终止本协议。如此类情况发生，您必须销毁本软件、及其所有副本及其全部组成部份。",
      "line20": "1.7 协议修改",
      "line21": "如果本协议的部分条款无效或无法执行，不影响其余条款的有效和执行。本协议只能由海能达公司授权人员修改。未经海能达公司授权，不可以对本协议及其条款做修改和补充。",
      "line26": "如您对本软件许可协议有任何问题，或您因任何原因希望联络海能达公司，请使用随本产品附上的地址联络海能达公司，或在万维网上访问海能达公司，网址为：http://www.hytera.com。"
    },
    "username": "用户名称"
  },
  "LteUser": {
    "pleaseSelectDatas": "请选择数据!",
    "cancel": "取消",
    "pdnProfileList": "关联PDN模板",
    "batchAddUserTip": "批量开户",
    "addUser": "新增用户",
    "logger": "日志",
    "ipv6_addr": "IMSI静态IPV6地址",
    "ODB": "ODB",
    "modUserSuccess": "修改用户成功",
    "pdnApnName": "接入点名称",
    "GRANTED": "GRANTED",
    "staticAddr": "签约静态地址",
    "selected": "已选择",
    "SubnetAtLeastTwoNodes": "子网中至少有两个节点或一个子网",
    "add": "开户",
    "item": "项",
    "nelist": "网元列表",
    "atleastone": "至少包含1条",
    "failed": "失败",
    "addBatch": "批量开户",
    "pleaseSelectOneData": "请选择一条数据!",
    "delConfirm": "确定要删除吗？",
    "atmost": "最多包含10000条",
    "imsireg": "不能以0开头",
    "DISABLED": "DISABLED",
    "character15": "15字符",
    "delRange": "范围删除",
    "profile_id": "用户签约模板ID",
    "success": "成功",
    "staticAddrNum": "静态地址个数",
    "exceedImsi": "批量开户数据中存在IMSI大于15位的数据",
    "imsi_status": "用户签约状态",
    "pdnType": "PDN类型",
    "staticAddrCount": "静态地址个数",
    "delUserSuccess": "删除用户成功",
    "imsi": "IMSI",
    "remove": "删除",
    "exceedMsisdn": "批量开户数据中存在MSISDN大于11位的数据",
    "search": "搜索",
    "ipv4_addr": "IMSI静态IPV4地址",
    "crumb": "开户管理/LTE管理/用户管理",
    "odb_1": "禁止所有Home Routed漫游模式的数据业务",
    "inquiry": "询问",
    "odb_0": "禁止用户所有数据业务",
    "pleaseSelectNE": "请选择网元",
    "removeRange": "范围删除",
    "msisdn": "移动用户号",
    "imsiRange": "IMSI范围",
    "length15": "固定长度15",
    "ipv4InfoCantEmpty": "ipv4地址不可为空",
    "configStaticIP": "配置静态IP地址",
    "refresh": "刷新",
    "batchDelUserTip": "批量删除",
    "addUserSuccess": "添加用户成功",
    "odb_3": "禁止漫游接入",
    "pdnProfileId": "PDN模板ID",
    "odb_2": "禁止所有Local Breakout漫游模式的数据业务",
    "wrong": "错误",
    "confirm": "确定",
    "modify": "修改",
    "addBatchUser": "批量开户",
    "imsiSearch": "输入IMSI号进行查询",
    "qryUserSuccess": "查询用户成功",
    "modUser": "修改用户",
    "imsi_odb": "ODB",
    "invalidnum": "无效的整数"
  },
  "DeployManagement": {
    "mergeBigFile": "正在合并、解压文件...",
    "instanceNum": "实例数",
    "editTemplate": "修改模板",
    "backConfirm": "确认回退当前服务?",
    "upgradeHistory": "升级记录",
    "deployManagement": "部署管理",
    "uploadStatus": "状态",
    "type": "类型",
    "tips_cancelUpload": "当前正在上传服务包,确定取消操作吗？",
    "upgradeStatus": "升级状态",
    "getTemplateRuleJsonFailed": "获取模板校验规则失败",
    "getingTopoInfo": "正在同步拓扑信息, 请稍候...",
    "password": "密码",
    "productVersion": "产品版本",
    "charLimit": "不能超过{0}个字符",
    "environmentName": "环境名称",
    "deleteLoad": "删除中...",
    "deployCount": "部署数量",
    "upgrageConfirm": "确认执行升级操作?",
    "environmentPort": "环境端口",
    "tips_serviceListEmpty": "服务包列表为空，请检查服务器是否有包存在!",
    "upgradeOptTip": "升级指令下发成功",
    "deliverTypeStr": "交付方式",
    "backOptTip": "回退指令下发成功",
    "environmentIP": "环境IP",
    "inputPlaceholder_nename": "请输入网元名称",
    "uploadConfirmTip": "服务包列表如下，确定要解析上传吗？",
    "serverManagerment": "服务管理",
    "version": "交付版本",
    "masterNotDel": "MASTER节点不能删除",
    "exist": "存在",
    "noEmptyStart": "名称禁止用空格开头",
    "fail": "失败",
    "operate": "操作",
    "expensionBtn": "扩容",
    "oneKeyDeployed": "一键部署",
    "uploadServPackage": "上传服务包",
    "unUpgrade": "未部署状态网元不可升级操作",
    "nodeInfo": "节点信息",
    "detail": "详情",
    "synSuccessTime": "同步成功时间",
    "savingDeploymentTemplate": "正在保存...",
    "versionCount": "版本数量",
    "nodeName": "节点名称",
    "topoMaxLength": "长度不能超过",
    "unDeploy": "未部署",
    "poc": "POC服务",
    "deviceUpgrageConfirm": "此服务下所有网元一起升级，是否继续?",
    "inputPlaceholder_netype": "请输入网元类型",
    "inputPlaceholder_version": "请输入查询版本",
    "installPkgPath": "内部包路径",
    "addingEnviroment": "正在添加环境, 请稍候...",
    "batchUploadServPackage": "批量上传服务包",
    "canNotAddK8sNode": "未部署不能进行添加",
    "serviceVerUpgrade": "服务版本升级",
    "pkgName": "服务包名称",
    "returnComfirm": "确认重启?",
    "nodeDesc": "节点描述",
    "environmentConfig": "环境配置",
    "runing": "运行中",
    "nameAndIPSame": "环境名称或IP不能重复！",
    "D_detail_serviceAndProcess": "服务\u0026进程ID",
    "uploadFinish": "上传完成",
    "product": "产品",
    "inputNumberRange": "输入值必须在{0}到{1}之间",
    "hasnotGPS": "当前没有GPS，无法删除",
    "upgradeable": "可升级",
    "templateConfirm": "确认对当前配置信息进行修改?",
    "deviceUpdate": "设备升级",
    "changeGPS": "更改GPS",
    "patchUpgrade": "补丁包安装操作",
    "serviceType_base": "基础",
    "bsDevice": "基站设备",
    "notExist": "不存在",
    "connected": "已接入",
    "localVersion": "本地版本",
    "deleting": "正在删除环境, 请稍候...",
    "pkgExists": "服务包已存在",
    "createTime": "创建时间",
    "dpCopyCount": "副本个数",
    "rolllbackable": "可回退",
    "upgradeBtn": "升级",
    "deploying": "正在部署, 请稍候...",
    "deployedDesc": "实例描述",
    "deployedInstanceCount": "已部署实例数",
    "dpSoftVersion": "DP版本",
    "shrinkage": "缩容",
    "deployFailure": "部署失败",
    "getDeployedTemplateFailed": "获取部署模板失败",
    "mergeResult": "合并解压文件完成 \n 关闭本页面并刷新列表查看进度",
    "rerunBtn": "重启",
    "exporting": "正在导出，请稍候...",
    "rerunTip_nosupport_status": "当前网元部署状态不支持重启",
    "neName": "网元名称",
    "internalIP": "内部IP",
    "rerunTip_nosupport_ne": "当前网元不支持重启",
    "deliverType": "支付类型",
    "deviceReback": "设备回退",
    "lunchTime": "上架时间",
    "versionTab": "所有版本",
    "unRun": "未运行",
    "selectProductVersion": "请选择产品版本号",
    "tips_noHasModExpansionParam": "当前实例无可更改的扩容参数",
    "uploading": "处理中...\n可以关闭页面刷新列表查看进度",
    "deviceVerSwitch": "设备版本切换",
    "nodeID": "节点ID",
    "invalidPackage": "服务包格式非法",
    "hasSamePackage": "已存在相同名称的服务包",
    "hasSamePatchPackage": "已存在相同名称的补丁包",
    "hasSameAdapterPackage": "已存在相同名称的适配包",
    "invalidPatch": "补丁包格式非法",
    "deployButton": "部署",
    "upgrading": "升级中",
    "deployedTab": "部署",
    "rollbacking": "回退中",
    "addDpEnvironment": "添加DP环境",
    "nodeIP": "节点IP",
    "expensionTip_nosupport": "当前网元不支持扩容",
    "parentNode": "node节点",
    "pleaseSelSameType": "请选择同类型服务",
    "nodeType": "节点类型",
    "pleaseSelectOneData": "请选择一条数据!",
    "noUpgradeVer": "没有可升级的版本",
    "synVersion": "同步版本",
    "invalidInt": "无效的整数",
    "netypeCount": "网元类型数量",
    "name": "名称",
    "syncTopoInfo": "同步拓扑信息",
    "deletePkg": "确认是否删除所选服务包?",
    "serviceType_ser": "业务",
    "serviceVerSwitch": "服务版本切换",
    "classify": "分类",
    "instanceName": "实例名称",
    "deployTab": "用户实例",
    "uploadProgress": "上传进度",
    "inputRangeIllegal": "输入值必须在1到65535之间",
    "saveTopoInfoFailed": "以下拓扑信息保存失败,对应版本的服务包不存在",
    "deployed": "已部署",
    "description": "描述",
    "delete": "删除",
    "runEnvironment": "运行环境",
    "AdapterManagement": "适配包管理",
    "batchUpgrade": "批量升级",
    "rerunLoad": "重启中...",
    "configParams": "配置参数",
    "getDeployedTemplateTips": "获取部署模板，请稍候...",
    "hasPkg": "是否存在升级包",
    "dpDeployedTemplate": "部署模板",
    "uploadDeployedTemplate": "上传部署模板",
    "saveButton": "保存",
    "value": "值",
    "runStatus": "运行状态",
    "searchUpgrade": "正在查询升级内容, 请稍候...",
    "deployedInstance": "部署实例",
    "alertRequired": "该项不能为空",
    "addEnvironmentFailed": "添加失败",
    "deployedStatus": "部署状态",
    "userName": "用户名",
    "pleaseFileType": "请上传XML文件",
    "exportXml": "导出",
    "pkgVersion": "版本号",
    "sysExternalIp": "外部IP",
    "nooperation": "不可操作",
    "displaySoftWareVersion": "节点版本",
    "cannotEditTemplate": "已部署完成不能修改！",
    "unRollBack": "未部署状态网元不可回退操作",
    "synchronization": "同步",
    "pleaseSelect": "请选择",
    "deployedDetail": "部署详情",
    "qryUpgradeInfo": "确认关闭当前升级查询页面吗?",
    "deployedNode": "部署节点",
    "failedInstanceName": "部署失败",
    "deployTotal": "部署总次数",
    "batchDeployIms": "批量部署IMS",
    "emptyTemplate": "模板为空不能进行部署!",
    "rebackBtn": "回退",
    "totalServicePkg": "一共{0}个服务包",
    "initStatus": "开站状态"
  },
  "MML": {
    "cancel": "取消",
    "cluster": "集群",
    "operationCancelled": "连续两次执行失败，操作取消",
    "notValidInteger": "请输入整数",
    "backup": "备份",
    "fileName": "文件名",
    "tipFileName": "文件名称格式:",
    "exeTimeOut": "执行超时",
    "upload": "上传",
    "neOffline": "网元 {0} 不在线，无法进行MML配置。",
    "operateTime": "操作时间",
    "executing": "执行中",
    "elementName": "网元名称：",
    "ue": "UE",
    "equipmentIp": "设备IP：",
    "maxBytesLength": "最大字节数为{0}",
    "resourceCode": "资源编码",
    "environmentName": "环境名称：",
    "mmlCommand": "MML命令 :",
    "selectFileButton": "浏览",
    "equipmentName": "设备名称：",
    "beginTime": "开始时间 :",
    "moTree": "Mo树",
    "moName": "Mo 名称",
    "notNull": "不能为空",
    "inputFileName": "请输入文件名并加后缀.txt",
    "validRange": "有效范围是{0}",
    "history": "历史记录",
    "execute": "执行",
    "notValidDate": "请输入正确日期",
    "ne": "网元",
    "cfgManagement": "配置管理",
    "mmlResponse": "MML响应 :",
    "device": "设备",
    "cfgPath": "配置文件路径",
    "exeSuccess": "执行成功",
    "notValidDomainOrIp": "请输入正确域名或ipv4",
    "execFailed": "执行失败，后台异常。",
    "buildMML": "生成MML语句",
    "mass": "批量",
    "currentNode": "节点列表",
    "selTypeAlert": "当前记录是备份记录，请选择恢复类型记录",
    "mml": "MML",
    "dangerOperTip": "该操作为高危操作，要继续进行吗？",
    "uploadCfgFile": "上传恢复",
    "instanceId": "实例Id",
    "queryData": "数据查询",
    "selBaseAlert": "请先选择基站，再查询",
    "selectFile": "请选择TXT类型的文件",
    "notValidTime": "请输入正确时间",
    "fillAlias": "请填写别名",
    "recover": "恢复",
    "validateFailed": "校验未通过",
    "recoverOrBackup": "备份/恢复",
    "deleteAll": "删除全部",
    "searchHolder": "输入并搜索...",
    "recoverFail": "配置恢复失败",
    "notValidIpv4": "请输入正确ipv4",
    "timeFormatError": "基准时间格式错误",
    "loadingTip": "加载中...",
    "batchRecover": "批量恢复",
    "versionCheck": "版本检查",
    "selBaseTime": "请选择基准时间",
    "command": "命令行",
    "cfgNeBackupOrRecover": "配置管理/网元备份恢复",
    "importCfg": "导入配置文件",
    "subnetInfo": "子网信息：",
    "single": "单条",
    "confirm": "确认",
    "selOneBase": "请至少选择一个基站",
    "atMost100": "最多选择100条数据",
    "notValidIpv6": "请输入正确ipv6",
    "noResult": "无",
    "endTime": "结束时间 :",
    "neType": "网元类型",
    "noCheck": "请至少选择一条数据",
    "executeTime": "定时执行",
    "neCfgRestoreConfirmTip": "该操作会修改基站配置数据并可能导致基站重启!您确定要继续吗?",
    neCannotBeEmpty: '网元id参数不能为空。',
    commandlineTabName: '命令行执行功能',
    incorrectFormat: 'MML命令格式错误。',
    notSupported: '不支持中文标点符号。',
    errorMessage: '错误信息',
    errorMessageTable: '错误信息表',
    successMessageTable: '成功信息表',
    spanTooLarge: '网元id数值范围过大。',
    result: '结果',
    neGlobalParameters: '网元全局参数',
    commandLineTooltip: '可以在\'ne\'字段中指定一个网元id范围以“-”分隔，以限制命令的执行范围，或者多个网元id之间用\',\'分隔。例如:\'QRY Cell: ne=10000-10010,10011;\'',
  },
  "Common": {
    "cancel": "取消",
    "next": "下一步",
    "import": "导入",
    "waiting": "请稍候...",
    "upload": "上传",
    "minLength": "长度最小值",
    "save": "保存",
    "adSearch": "高级搜索",
    "error": "错误",
    "tips": {
      "ldapAccountForbidDelete": "LDAP账户禁止删除",
      "ldapAccountForbidChangePassword": "LDAP账户禁止修改密码",
      "selectOne": "请选择一条记录",
      "noSelect": "未选中任何数据",
      "confirmForce": "确认强制退出所选用户？",
      "success": "操作成功",
      "successData": "操作成功,重新登录后生效",
      "failure": "操作失败",
      "failureData": "操作失败,请确认规则是否被使用中",
      "onlyOneSelect": "只能选择一条记录",
      "confirmTip": "确认删除所选记录？"
    },
    "minValue": "数字最小值",
    "minByteNum": "最小字节数为",
    "neOffLine": "网元 {0} 不在线",
    "warning": "警告",
    "ok": "确定",
    "day": "天",
    "export": "导出",
    "close": "关闭",
    "all": "全部",
    "Listupload": "批量上传",
    "previous": "上一步",
    "maxValue": "数字最大值",
    "refresh": "刷新",
    "minute": "分钟",
    "confirm": "确认",
    "downloadFile": "下载文件",
    "inputRange": "输入范围",
    "success": "提示",
    "information": "信息",
    "detail": "详情",
    "maxByteNum": "最大字节数为",
    "maxLength": "长度最大值"
  },
  "ej2Components": {
    "dialog": {
      "close": "关闭"
    },
    "tab": {
      "closeButtonTitle": "关闭"
    },
    "pager": {
      "All": "全部",
      "currentPageInfo": "第 {0} 页 共 {1} 页",
      "pagerDropDown": "每页条数",
      "totalItemsInfo": "({0} 条)",
      "nextPageTooltip": "下一页",
      "nextPagerTooltip": "到下一页",
      "previousPageTooltip": "上一页",
      "lastPageTooltip": "最后一页",
      "pagerAllDropDown": "条数",
      "previousPagerTooltip": "到前一页",
      "firstPageTooltip": "首页"
    },
    "numerictextbox": {
      "decrementTitle": "减少",
      "incrementTitle": "增加"
    },
    "uploader": {
      "cancel": "取消",
      "inProgress": "下载",
      "removedSuccessMessage": "已成功删除文件",
      "Upload": "上传",
      "removedFailedMessage": "该文件无法删除",
      "uploadFailedMessage": "上传失败",
      "delete": "删除文件",
      "remove": "删除文件",
      "Clear": "清除",
      "Browse": "浏览",
      "readyToUploadMessage": "准备上传",
      "invalidFileType": "文件类型不允许",
      "dropFilesHint": "删除文件",
      "uploadSuccessMessage": "上传成功"
    },
    "grid": {
      "EmptyRecord": "无记录"
    },
    "daterangepicker": {
      "customRange": "定制区域",
      "cancelText": "取消",
      "startLabel": "选择开始日期",
      "selectedDays": "选定日期",
      "days": "天数",
      "placeholder": "选择一个区域",
      "endLabel": "选择结束日期",
      "applyText": "确定"
    },
    "timepicker": {
      "placeholder": "选择时间"
    },
    "dropdowns": {
      "noRecordsTemplate": "没有找到记录",
      "actionFailureTemplate": "请求失败"
    },
    "datepicker": {
      "today": "今天",
      "placeholder": "请选择一个日期"
    },
    "chart": {
      "ZoomOut": "缩小",
      "Zoom": "缩放",
      "Pan": "平移",
      "Reset": "重置",
      "ZoomIn": "放大"
    },
    "datetimepicker": {
      "today": "今天",
      "placeholder": "请选择日期和时间"
    }
  },
  "Observe": {
    "filterConditions": "过滤条件",
    "struct": "结构体",
    "cancel": "取消",
    "region": "地区",
    "neId": "网元ID",
    "fileName": "文件名称",
    "maximumMissionNumber": "任务跟踪数量最多为5个!",
    "taskDeletion": "删除任务",
    "resourcesList": "资源列表",
    "extBuff": "扩展信息字段",
    "publicMessage": "公共消息",
    "taskTracking": "任务跟踪",
    "serviceState": "当前业务流程状态",
    "messageType": "消息类型",
    "reportInfo": "信息",
    "realTimeFiltering": "实时过滤",
    "text": "文本",
    "issued": "待下发",
    "taskStatus": "任务状态",
    "apn": "APN",
    "taskID": "任务ID",
    "extLen": "扩展字段长度",
    "suspendTask": "挂起任务",
    "active": "执行",
    "downloadFile": "下载文件",
    "realTime": "实时",
    "failTime": "失败上报发生时间",
    "observeManage": "失败观察管理",
    "mission": "跟踪",
    "stop": "暂停",
    "taskName": "任务名称",
    "detail": "详情",
    "queryTrack": "信令查询",
    "createTask": "创建任务",
    "status": "状态",
    "taskSrc": "任务来源",
    "greate": "待执行",
    "autoActivationFailed": "自动激活失败",
    "save": "保存",
    "taskList": "任务列表",
    "failcode": "失败码",
    "pleaseNameEnterQuery": "请输入任务名称查询",
    "refreshTask": "刷新任务",
    "addTask": "添加任务",
    "result": "执行结果",
    "search": "查询",
    "file": "文件",
    "creatTime": "创建时间",
    "pleaseSelectNE": "请选择资源",
    "noDataToExport": "没有数据无法导出",
    "taskIsPending": "任务处于挂起状态",
    "startTime": "开始时间",
    "operating": "操作",
    "close": "关闭",
    "endTimeGreaterThanStartTime": "结束时间应大于开始时间",
    "userPlaceholder": "请输入标准格式(最多可输入10个用户号码)：460980123456788,460980123456789",
    "historyFilter": "历史过滤",
    "systemId": "系统ID",
    "resourceID": "资源ID",
    "expression": "表达式",
    "activationTask": "激活任务",
    "userId": "用户标识",
    "confirm": "确认",
    "filter": "过滤",
    "taskTypeID": "模版ID",
    "endTime": "结束时间",
    "complete": "完成",
    "resourceType": "资源类型",
    "callID": "Call-ID",
    "userPlaceholderHss": "请输入标准格式(最多可输入10个PUI或PVI)：sip:+123456@XX.com,tel:+1234567,1234567@xx.com",
    "searchNe": "搜索网元",
    "reIssued": "重新下发",
    "neName": "网元名称",
    "reportLevel": "上报级别",
    "trackingCommunity": "跟踪小区",
    "hangup": "挂起",
    "pleaseEnterQuery": "请输入查询条件",
    "reportType": "上报类型",
    "download": "下载",
    "duplicateContent": "用户号码重复",
    "finish": "完成",
    "export": "导出",
    "taskDetails": "任务详情",
    "add": "添加",
    "all": "全部",
    "importTrackData": "信令数据导入",
    "signalingDetails": "信令详情",
    "tracing": "执行中",
    "level": "级别",
    "attributeValues": "字段名称",
    "resourceName": "资源名称",
    "queryError": "查询错误",
    "notGenerated": "未生成相关文件",
    "importFileError": "导入文件错误",
    "importFileFormatError": "导入文件错误",
    "deleteTaskInfo": "删除任务会同时删除相关的上报文件，是否删除该任务？",
    "moduleNo": "模块标识",
    "success": "成功",
    "monitorTrack": "任务监控",
    "standardInterface": "标准接口",
    "activation": "激活",
    "missionAlreadyCompleted": "任务已经完成",
    "import": "导入",
    "taskInProgress": "任务正在执行中",
    "measuringObject": "测量对象",
    "allUserTag": "全用户跟踪标志",
    "NElist": "网元列表",
    "error": "失败",
    "delete": "删除",
    "pleaseSelectMeasuringObject": "请选择测量对象",
    "signalDataExport": "失败观察数据导出",
    "attributeName": "属性名称",
    "reportWarning": "警告",
    "missionCompleted": "完成任务",
    "deleteFile": "是否删除文件？",
    "userTrack": "用户跟踪",
    "searchResource": "搜索资源",
    "sliceId": "网元切片标识",
    "curRecvEvent": "当前收到消息",
    "userIdList": "用户跟踪列表",
    "implementation": "执行中",
    "failTrack": "失败跟踪",
    "contextId": "用户上下文ID",
    "reportError": "错误",
    "invalidFormat": "无效的格式",
    "fieldIsRequired": "该项不能为空",
    "systemOutTime": "系统连接超时",
    "pleaseSelect": "请选择",
    "time": "时间",
    "invalidChart": "无效的特殊字符",
    "internalSignaling": "内部信令"
  },
  "Alarm": {
    "eqType":"基站类型",
    "validityTime":"过期时间",
    "eqType_1": "商用",
    "eqType_2": "临时",
    "eqType_4": "调试",
    "cancel": "取消",
    "pleaseEnterAlmId": "请输入事件ID",
    "numberOfWarningAlarms": "警告告警数量",
    "notitylevel": "按级别通知",
    "messageNo": "流水号",
    "confirmGhost": "你确定要恢复吗？恢复后无法复原",
    "alarmNum": "告警总量",
    "notInput": "不允许输入",
    "rulename": "规则名称",
    "notifyuser": "通知用户组",
    "alarmType_3": "环境",
    "alarmType_2": "业务",
    "alarmType_1": "传输",
    "alarmType_0": "设备",
    "alarmSource": "告警源",
    "synchronize": "同步",
    "eventNum": "事件总量",
    "edit": "编辑",
    "syncError": "同步失败",
    "callContent": "推送内容",
    "confirmUser": "确认人",
    "xxkzinfo3": "详细扩展信息3",
    "xxkzinfo4": "详细扩展信息4",
    "xxkzinfo1": "详细扩展信息1",
    "alarmType_4": "服务质量",
    "xxkzinfo2": "详细扩展信息2",
    "warnfilter": "特殊过滤",
    "notValidDate": "请输入有效的日期",
    "syncSuccess": "同步成功",
    "callBackLog": "推送日志",
    "envName": "环境名称",
    "statisticType": "统计类型",
    "startdatenull": "开始日期不能为空",
    "notificationTimeRule": "通知时间规则",
    "alarmID": "告警ID",
    "callResult": "推送结果",
    "filteridentity": "过滤标识",
    "byType": "按类型",
    "extraInfo": "附加信息",
    "notityform": "通知类型",
    "eventSubscription": "事件订阅",
    "notSingleQuoteOrBackslash": "不允许单引号或反斜杠",
    "notifyedit": "编辑时间",
    "equipmentType": "设备类型",
    "alarmCount": "告警次数",
    "pleaseEnterAlarmName": "请输入告警名称",
    "broadbandInquiry": "告警查询",
    "alarmLevel": "告警级别",
    "analysisAlarm": "告警分析",
    "close": "关闭",
    "deployIp": "部署Ip",
    "createtime": "创建日期",
    "callBackUrl": "推送地址",
    "refresh": "刷新",
    "endtime": "结束日期",
    "defaultThanmax": "默认图层不能大于最大图层",
    "confirm": "确认",
    "createTime": "产生时间",
    "cabinet": "柜号",
    "inputTip": "请输入标题搜索",
    "alarmDec": "告警描述",
    "numberOfMajorAlarms": "主要告警数量",
    "clearTime": "清除时间",
    "notificationTimenull": "通知时间周期不能为空",
    "currentAlarmSummary": "当前告警汇总",
    "thisWeek": "本周",
    "inputTipCallUrl": "请输入第三方地址",
    "addFilterRule": "添加过滤规则",
    "advancedSearchSetting": "高级搜索-条件设置",
    "enableAlarmNoticeconfirm": "确定要启用选中告警规则吗",
    "eventLevel": "事件级别",
    "notificationMethodnull": "通知方式不能为空",
    "redefineModigy": "重定义修改",
    "equipmentName": "设备名称",
    "export": "导出",
    "exportAll": "导出全部",
    "singleNetwork": "单网元",
    "isvirtual": "虚拟化标识",
    "add": "添加",
    "eventId": "事件ID",
    "alarmName": "告警名称",
    "eventDetails": "事件详细信息",
    "callLog": "推送日志",
    "success": "成功",
    "inputTipCallName": "请输入名称",
    "editBlockingRule": "修改屏蔽规则",
    "alarmDetails": "告警详细信息",
    "saveMapSuccess": "保存地图成功",
    "unconfirm": "反确认",
    "frame": "框号",
    "thisYear": "今年",
    "subSlot": "子槽号",
    "hidden": "隐藏",
    "nenull": "告警源信息不能为空",
    "notityinterval": "通知周期",
    "remove": "删除",
    "redefine": "重定义",
    "too_many_checked": "当前选中多条数据",
    "minValueIs": "最小值为",
    "eventLog": "事件日志",
    "ghostAllSystem": "所有系统，全部复位成功",
    "callBackName": "推送名称",
    "alarmOper": "告警处理",
    "minThandefault": "最小图层不能大于默认图层",
    "alarmSocket": "实时告警",
    "notityitem": "按告警项通知",
    "print": "打印",
    "alarmSync": "告警同步",
    "alarmSyncConfirmTip": "确认同步所有告警数据?",
    "alarmSyncLoad": "告警同步中...",
    "notifyUserNotExist": "通知用户组不存在",
    "automaticConfirmation": "自动确认",
    "fieldIsRequired": "该项不能为空",
    "notifyUserGroup": "通知用户组",
    "eventCause": "事件产生原因",
    "envType": "环境类型",
    "nodeSelect": "节点选择",
    "numberOfCriticalAlarms": "严重告警数量",
    "EndTimeLessThanStartTime": "结束时间不能小于开始时间",
    "pleaseChoose": "请选择",
    "confirmSettingParameter": "已选项参数不能为空",
    "neType": "网元类型",
    "noPermission": "无权限，你不是确认者",
    "filterSetting": "过滤条件设置",
    "exportSetting": "数据导出-条件设置",
    "starttime": "开始日期",
    "xxdwinfo1": "详细定位信息1",
    "xxdwinfo2": "详细定位信息2",
    "blockingRule": "屏蔽规则",
    "showSetting": "告警显示设置",
    "sysDescription": "系统描述",
    "clearType": "清除类型",
    "thisMonth": "今月",
    "unenableAlarmNoticeconfirm": "确定要停用选中告警规则吗",
    "editRules": "修改规则",
    "restoration": "复位",
    "no_checked": "未选中任何数据",
    "unenableconfirm": "确定要停用选中屏蔽规则吗",
    "repeatVersion": "导入时请选择同一版本的基站",
    "alarmHidden_16": "确认状态",
    "alarmHidden_15": "产生时间",
    "alertSubscription": "告警订阅",
    "alarmHidden_18": "确认人",
    "virtualNet": "虚拟化网元",
    "pleaseEnterTheQueryCriteria": "告警ID/描述/告警名称/确认人",
    "alarmHidden_17": "确认时间",
    "alarmHidden_12": "环境名称",
    "alarmHidden_11": "环境类型",
    "confirmTime": "确认时间",
    "alarmHidden_14": "虚拟化标识",
    "alarmHidden_13": "告警位置",
    "eventType": "事件类型",
    "numberOfMinorAlarms": "次要告警数量",
    "alarmHidden_10": "部署Ip",
    "alarmClearStatus_0": "未清除",
    "notificationRuleName": "通知规则名称",
    "realTime": "实时",
    "isOpen": "是否开启",
    "callFail": "推送失败",
    "pleaseSelectNe": "请选择网元节点",
    "alarmLevelnull": "告警级别不能为空",
    "alarmUpdate": "告警升级",
    "brdType": "单板类型",
    "topAlarm": "告警排行榜",
    "status": "状态",
    "shield": "屏蔽",
    "statisticType_0": "全网",
    "periodic": "周期性",
    "statisticType_1": "子网",
    "statisticType_2": "网元",
    "eventSource": "事件源",
    "alarmClearStatus_1": "已清除",
    "editFilterRule": "修改过滤规则",
    "physics": "物理网元",
    "datevalidate": "结束日期应大于开始日期",
    "totalNumberOfAlarms": "总告警数量",
    "logId": "日志ID",
    "event": "事件",
    "manul": "手动",
    "alarmHidden_2": "告警名称",
    "alarmHidden_3": "告警级别",
    "alarmHidden_1": "告警ID",
    "confirmSetting": "自动确认配置页面",
    "neSelect": "网元选择",
    "notifytemplate1": "模板1",
    "notifytemplate2": "模板2",
    "notInputblank": "不允许输入  空格",
    "filter": "过滤",
    "modifiedSystemFailed": "该告警不允许修改",
    "addRules": "添加规则",
    "disable": "停用",
    "able": "启用",
    "alarmHidden_8": "设备名称",
    "enddatenull": "结束日期不能为空",
    "alarmHidden_9": "设备标识符",
    "alarmHidden_6": "网元名称",
    "alarmHidden_7": "设备类型",
    "alarmHidden_4": "告警类型",
    "historyAlarm": "历史告警",
    "alarmStatistics": "告警统计",
    "statistics": "统计",
    "alarmHidden_5": "网元类型",
    "confirmCycle": "确认周期",
    "pleaseSelectEndTime": "请选择结束时间",
    "auto": "自动",
    "notifystart": "开始时间",
    "advancedSearch": "高级查询",
    "byName": "按名称",
    "eventDes": "事件描述",
    "neName": "网元名称",
    "alarmConfirmStatus_1": "已确认",
    "alarmConfirmStatus_0": "未确认",
    "addBlockingRule": "添加屏蔽规则",
    "insideAlarmNotAllowShield": "UNMS内部告警不支持屏蔽",
    "unconfirm_unconfirm": "状态为未确认，无法取消确认",
    "callTitle": "推送标题",
    "day": "天",
    "deployIpId": "设备标识符",
    "pleaseSelectStartTime": "请选择开始时间",
    "notifyend": "结束时间",
    "neEventFDN": "事件位置",
    "maxValueIs": "最大值为",
    "alarmDeleteConfirm": "确认删除么?",
    "additionInfo": "补充信息",
    "alarmStatus": "告警状态",
    "currentAlarm": "当前告警",
    "alarmnull": "告警信息不能为空",
    "maxLength": "文字长度不能超过",
    "alarmredefned_3": "重定义级别/重定义描述",
    "unclearedDuration": "未清除时长(秒)",
    "enablewarnfilter": "确定要启用选中警告过滤吗",
    "alarmredefned_4": "重定义修复建议",
    "alarmNotice": "告警通知",
    "alarmredefned_5": "重定义修复建议/重定义级别",
    "alarmredefned_6": "重定义修复建议/重定义描述",
    "sysType": "系统类型",
    "alarmredefned_7": "重定义修复建议/重定义描述/重定义级别",
    "callBack": "告警推送",
    "cause": "告警产生原因",
    "remark": "备注",
    "slot": "槽号",
    "error": "失败",
    "subnetName": "子网名称",
    "alarmAynchronize": "告警同步",
    "eventAynchronize": "事件同步",
    "hour": "小时",
    "minThanmax": "最小图层不能大于最大图层",
    "methodToInforme": "通知方式",
    "callSuccess": "推送成功",
    "advise": "修复建议",
    "alarmManage": "告警管理",
    "alarm": "告警",
    "alreadyModifiedSystem": "所有系统，全部修改成功",
    "thisDay": "今日",
    "notInteger": "请输入有效的整数",
    "alarmRedirect": "告警重定义",
    "fhostSystemFailed": "复位失败的系统",
    "clear": "清除",
    "confirmState": "确认状态",
    "neAlarmFDN": "告警位置",
    "clearState": "清除状态",
    "enableconfirm": "确定要启用选中屏蔽规则吗",
    "minute": "分钟",
    "alarmType": "告警类型",
    "unenablewarnfilter": "确定要停用选中警告过滤吗",
    "acknowledge": "确认",
    "clearUser": "清除人",
    "filterRule": "过滤规则",
    "indicatorThreshold": "指标告警阈值",
    "alarmLevel_1": "主要",
    "notifytemplate": "通知模板",
    "alarmLevel_0": "紧急",
    "alarmredefned_1": "重定义级别",
    "alarmLevel_3": "警告",
    "callTime": "推送时间",
    "alarmredefned_2": "重定义描述",
    "alarmLevel_2": "次要",
    "addIndicatorAlarmThreshold": "添加指标告警阈值",
    "modifyIndicatorAlarmThreshold": "修改指标告警阈值",
    "addBusyTimeIndicatorAlarmThreshold": "添加指标告警时间范围",
    "modifyBusyTimeIndicatorAlarmThreshold": "修改指标告警时间范围",
    "upperLimitOfTheBusyTimeThreshold": "忙时阈值上限",
    "lowerLimitOfTheBusyTimeThreshold": "忙时阈值下限",
    "upperLimitOfTheIdelTimeThreshold": "闲时阈值上限",
    "lowerLimitOfTheIdelTimeThreshold": "闲时阈值下限",
    "setTheBusyHourTimeRangeTips": "点击按钮添加忙时时间范围，此时间为基站本地时间",
    "dateRange": "时间段",
    "K0000020030": "RRC连接建立成功率",
    "K0000020031": "S1连接建立成功率",
    "K0000020032": "初始Erab建立成功率",
    "K0000020052": "新增Erab建立成功率",
    "K0000020062": "切换入Erab建立成功率",
    "K0000020051": "Erab_掉线率",
    "K0000020092": "CCSR语音成功率QCI1",
    "K0000020093": "DCSR数据成功率QCI8,9",
    "K0000020074": "会话连接建立成功率",
    "K0000020174": "eNB内小区间同频切换出成功率",
    "K0000020175": "eNB内小区间同频切换入成功率",
    "K0000020180": "eNB内小区间异频切换出成功率",
    "K0000020181": "eNB内小区间异频切换入成功率",
    "K0000020172": "eNB间X2同频切换出成功率",
    "K0000020173": "eNB间X2同频切换入成功率",
    "K0000020178": "eNB间X2异频切换出成功率",
    "K0000020179": "eNB间X2异频切换入成功率",
    "K0000020170": "eNB间S1同频切换出成功率",
    "K0000020171": "eNB间S1同频切换入成功率",
    "K0000020176": "eNB间S1异频切换出成功率",
    "K0000020177": "eNB间S1异频切换入成功率",
    "buiInterfaceLicenseDisable": "NBI interface license设置为无效！同步操作不允许进行！",
    "theLowerLimitValueShouldNotBeHigherThanTheUpperLimitValue": "上限值应高于下限值",
    "pleaseAddTimePeriod": "请添加时间段",
    "youCanAddAMaximumFfFiveTimeSegments": "最多只能添加5个时间段",
    "TheTimeRangesOverlapResetTheTimeRanges": "时间段有重叠，请重新设置",
    "moreThanMaxConcurrentExportNum":"超过最大同时导出数量",
    "moreThanMaxExportDetailNum":"超过最大导出明细数量",
    "resultCountIsZero":"查询结果数量为0",
    "theDeviceIsOccupied": "设备被占用，请重新选择其他设备",
    "systemMonitorTaskExceedsTheSpecifiedThreshold": "系统监控任务中CPU阈值或者内存阈值超出设定值",
    "NbiSwitchDisable": "北向接口许可证配置为不可用",
    "ruleExpired":"规则已过期"
  },
  "Software": {
    "cancel": "取消",
    "appupdate": "APP软件管理",
    "bak_fail": "切换失败",
    "updateBSMax": "最多支持100个基站同时升级",
    "updatePatchBSMax": "最多支持100个基站同时升级",
    "pkgType": "版本包类型",
    "upload": "上传版本包",
    "dataUpload": "数据上载",
    "partSucc": "部分成功",
    "endipaddr": "终止IP",
    "selectDeviceGrp": "请选择设备组",
    "td_taskType": "任务类型",
    "tips_cancelUpload": "当前正在上传升级包,确定取消操作吗？",
    "import_DHCP_error": "请检查您要添加的数据是否已经存在。",
    "import_DHCP_error1": "请先将neId网元添加到设备列表中。",
    "import_DHCP_error2": "DHCP数据上传失败。",
    "tips_cancelPatchUpload": "当前正在上传补丁包,确定取消操作吗？",
    "softManage_Lib": "软件管理/版本库管理",
    "upda_fail": "升级失败",
    "upgrademanage": "软件管理",
    "td_progress": "进度",
    "enterKeywordSearch": "请输入网元名称进行搜索",
    "downloadSuccess": "下载成功",
    "softManage_Automantic": "软件管理/基站IP自动分配",
    "no_checked": "未选中任何数据",
    "exportdata": "导出数据",
    "exportTemplateTip": "确认导出窗模板？",
    "td_operationType": "操作类型",
    "td_createTime": "创建时间",
    "onlyReserveAllowed": "只能激活版本包为备用状态的版本",
    "pleaseEnterTheQueryCriteria": "请输入查询条件",
    "active": "激活",
    "patch_uninstall":"补丁卸载",
    "patch_delete":"补丁删除",
    "patch_fall_back":"补丁回退",
    "POCUpgrade": "MPTT上传",
    "downloadFailure": "未下载",
    "uploaderStr": "上传人",
    "softManage_AppUpgrade": "系统管理/APP软件管理",
    "fail": "失败",
    "dl_succ": "下载成功",
    "reserved": "备用",
    "pleaseSelectNe": "请选择网元",
    "td_pkgStatus": "版本包状态",
    "selectOprObj": "请选择操作对象",
    "uploadExcel": "上传",
    "addtask": "添加升级任务",
    "versiondescription": "版本描述",
    "DlandAt": "下载；激活",
    "td_neName": "设备类型",
    "waitforexe": "等待执行",
    "dl_noneed": "不需下载",
    "pocupgrade": "Poc升级",
    "messionExist": "存在正在执行的任务",
    "DHCPIsLoading": "DHCP数据正在加载...",
    "updManage": "升级管理",
    "selectDevice": "请选择设备",
    "save": "保存",
    "que_version": "软件管理/版本查询",
    "distributionState": "分配情况",
    "notifystatus": "通知状态",
    "uploader": "上传人",
    "query_frameId": "框号",
    "deviceNotExistInfo": "没有对应的设备进行升级!",
    "runversion": "运行版本",
    "storeversion": "存储版本",
    "close": "关闭",
    "caution": "注意：选择“激活”设备将重启",
    "cautionPatchBack": "注意：选择“补丁卸载”和“补丁回退”设备将重启",
    "informed": "已通知",
    "rollback": "切换",
    "queryAppSoftwareInfo": "查询APP管理信息",
    "queVersion": "查询版本中",
    "vmyes": "是",
    "td_packageName": "升级包名",
    "patchName": "补丁包名",
    "zipTag": "补丁包标签",
    "patchMadeTime": "上传时间",
    "td_executionTime": "计划执行时间",
    "td_finishTime": "操作完成时间",
    "refresh": "刷新",
    "Uploading": "文件正在上传...",
    "deleteTip": "确认删除?删除后不可恢复！",
    "selectOprType": "请选择操作类型",
    "selectOprTypePatch": "卸载和回退只能选择一个！",
    "query_cabinetId": "柜号",
    "ExecuteFile": "执行文件",
    "filter": "过滤",
    "Searching": "查询中...",
    "startipaddr": "起始IP",
    "downloadstatus": "下载状态",
    "AddPOCVersion": "上传MPTT软件包",
    "td_result": "结果",
    "tdMML_result": "MML执行结果",
    "tdPatch_result": "补丁执行结果",
    "pleaseUploadFile": "请上传文件",
    "validateInputInfo": "输入数据有误,请检验",
    "devicegroupname": "设备组名称",
    "notstart": "未开始",
    "up_fail": "上传失败",
    "query_appVersion": "软件版本",
    "DlandAtandUl": "下载；激活；上载",
    "selectPkg": "请选择升级包",
    "versionName": "版本名称",
    "enterKeywordSearchDevice": "请输入设备名称进行搜索",
    "vmno": "否",
    "backcaution": "注意：确认后设备将重启",
    "exporttemplate": "导出模板",
    "updataOper": "升级操作",
    "updataOperPatch": "补丁回退操作",
    "download": "下载",
    "td_status": "状态",
    "downloading": "下载中",
    "query_remarks": "说明",
    "versionNo": "版本号",
    "export": "导出",
    "subnetmask": "子网掩码",
    "opetask": "操作任务",
    "add": "添加",
    "lte_udp_version": "版本升级",
    "lte_patch_version": "补丁包安装",
    "lte_patch_length_alert": "补丁包不能超过20个",
    "lte_pkg_length_alert": "升级包不能超过10个",
    "rb_version": "版本回退",
    "rb_patch_version":"补丁回退删除",
    "serialNumber": "电子序列号",
    "td_isSupportRbk": "是否支持切换",
    "softManage_Upd": "软件管理/版本升级",
    "softManage_patch": "设备管理/补丁包安装",
    "ipAddress": "IP地址",
    "AtandUl": "激活；上载",
    "done": "已结束",
    "MCSUpgrade": "MCC上传",
    "pkgMode": "版本模式",
    "query_slotId": "槽号",
    "nename": "网元名称",
    "success": "成功",
    "selectAtLeastOne": "请选择至少一条数据!",
    "nonallocated": "未分配",
    "dl_already": "已存在",
    "td_packageTag": "软件包标签",
    "import": "导入",
    "netask": "设备任务",
    "td_taskId": "任务编号",
    "description": "描述",
    "td_fileName": "文件名称",
    "td_mainPkgVer": "基准版本号",
    "redo": "重新开始",
    "keySerach": "请输入关键词进行搜索",
    "td_packageVer": "版本号",
    "delete": "删除",
    "dataIsLoading": "数据正在加载...",
    "running": "运行",
    "dl_fail": "下载失败",
    "td_detail": "详情",
    "common": "公共",
    "too_many_checked": "当前选中多条数据",
    "rollbackOper": "回退操作",
    "DlandUl": "下载；上载",
    "softManage_back": "软件管理/版本回退",
    "MD5Code": "MD5",
    "allocated": "已分配",
    "uploadtime": "上传时间",
    "td_neID": "设备名称",
    "progressing": "执行中",
    "downloadtasklist": "下载任务列表",
    "AddMCSVersion": "上传MCC软件包",
    "addRollbacktask": "添加回退任务",
    "td_isSupportMS": "是否支持主备",
    "tscipautodistribute": "基站IP自动分配",
    "pkgMadeTime": "版本包制作时间",
    "MD5CheckFail": "MD5校验失败",
    "RequiredLength": "输入数据长度应该为",
    "unInformed": "未通知",
    "uploadTpkg": "上传升级包",
    "RbandUl": "切换；上载",
    "PatchUninstall": "补丁卸载",
    "PatchFallback": "补丁回退",
    "patchPush":"下载",
    "patchActive":"激活",
    "patchPushActive":"下载;激活",
    "gateway": "网关",
    "pleaseEnterDevicegroupname": "请输入设备组名称",
  },
  "dhcpEmsVlan":{
    "neId": "网元ID",
    "esn": "Esn码",
    "vlan_id": "Vlan Id",
    "is_assign":"是否分配",
    "status_success":"已分配",
    "status_failed":"未分配",
    "ip": "Ip",
    "subnet_mask": "子网掩码",
  },
  "NSMF": {
    "shareable": "可被共享",
    "sliceNum": "切片总数",
    "instance": "实例化",
    "downlinkName": "下行流量",
    "amfShareNe": "AMF可被共享网元",
    "shareNe": "共享网元",
    "nsmfThroughput": "吞吐量",
    "deleteNSI": "是否删除此网络切片实例？",
    "nsmfUsed": "已使用",
    "nsmfVersionNum": "版本号",
    "nsmfNotUsed": "未使用",
    "sdRepeat": "SD重复",
    "mcc": "MCC",
    "nsmfAppIntroduction": "应用介绍",
    "deployinfo": "选中的网元需填写部署信息",
    "udmShareNe": "UDM可被共享网元",
    "createServiceProfile": "添加网络切片模板",
    "deactivate": "失活",
    "pleaseEnterQuery": "请输入查询条件",
    "aliasNoEmpty": "别名不能为空",
    "gbpsRangeIllegal": "输入值必须在1到20之间",
    "nsmfPhysical": "物理资源",
    "sst": "SST",
    "administrativeState": "激活状态",
    "deleteSliceProfile": "是否删除此网络切片子网模板？",
    "neDeploy": "网元配置",
    "cfgExport": "配置导入导出",
    "checkParam": "配置参数校验",
    "add": "添加",
    "addInstanceLoading": "部署中，请稍候...",
    "deactivateNSSIInfo": "是否失活此网络切片？",
    "sstRepeat": "SST重复",
    "activateNSSIInfo": "是否激活此网络切片？",
    "deleteNSSI": "是否删除此网络切片子网实例？",
    "gbps": "吞吐量",
    "oamMore": "OAM一对多",
    "runMode": "运行模式",
    "nsmfMemory": "内存",
    "nsmfNember": "在线用户数",
    "activateNSIInfo": "是否激活此网络切片？",
    "success": "成功",
    "numberRangeIllegal": "输入值必须在1到10000之间",
    "activate": "激活",
    "name": "模板名称",
    "nsmfAlias": "别名:",
    "disableSend": "最少勾选一条网元并填写信息",
    "serviceProfile": "网络切片模板",
    "selectSliceProfile": "请选择子网模板",
    "ipNoEmpty": "IP不能为空",
    "deleteServiceProfile": "是否删除此网络切片模板？",
    "instanceName": "切片实例名称",
    "nsi": "网络切片实例",
    "inputRangeIllegal": "输入值必须在1到16777215之间",
    "latency": "延迟",
    "administrativeState0": "失活",
    "sliceProfile": "网络切片子网模板",
    "administrativeState1": "激活",
    "envChoice": "环境选择",
    "delete": "删除",
    "ipCheck": "无效的IP",
    "caps": "用户会话数",
    "sd": "SD",
    "gnbNumRangeIllegal": "输入值必须在1到128之间",
    "gnbNum": "基站数",
    "nsmfShelfTime": "上架时间",
    "amfDeployNum": "AMF部署数量",
    "udmShare": "UDM共享属性",
    "disableShare": "不可被共享",
    "nsmfMonitor": "切片监控",
    "nsmfDeliveryType": "交付类型",
    "sstSdRepeat": "SST与SD组合不能重复",
    "shareProperty": "共享属性",
    "mnc": "MNC",
    "serviceProfileId": "关联网络切片模板",
    "nsmfDescription": "描述:",
    "maxNumberofUEs": "开户数",
    "maxMumberOfUe": "最大用户数",
    "nsmfBusiness": "业务资源",
    "nssi": "网络切片子网实例",
    "refresh": "刷新",
    "nok8sNode": "未选择节点",
    "monitor": "监控",
    "upfDeployNum": "UPF部署数量",
    "createSliceProfile": "添加网络切片子网模板",
    "uplinkName": "上行流量",
    "amfShare": "AMF共享属性",
    "deactivateNSIInfo": "是否失活此网络切片？",
    "sharePropertyNe": "可被共享网元",
    "nsmfCpu": "CPU",
    "nsmfManage": "网络切片管理",
    "instanceSliceProfileName": "切片子网实例名称",
    "namespace": "命名空间",
    "validChart": "输入有效字符",
    "oamOne": "OAM一对一",
    "capsRangeIllegal": "输入值必须在1到20000之间",
    "deployAlias": "别名",
    "editLicense": "修改License控项",
    "batchInitNECfg": "批量开站"
  },
  "MCS": {
    "cancel": "取消",
    "highUser": "高级用户",
    "mcsManagement": "MCS管理",
    "userInfo": "用户信息",
    "mod": "修改",
    "zoomOut": "缩小",
    "del": "删除",
    "sendingMML": "正在发送MML",
    "voiceBusiness": "语音业务",
    "ftpUploadFailed": "ftp上传失败",
    "blackImport": "用户黑名单信息导入",
    "cellNumber": "小区号码",
    "cover": "覆盖",
    "startTask": "开始任务",
    "au_vi": "录音/录像服务器",
    "delUser": "删除用户",
    "stunKillStatus": "遥晕遥毙状态",
    "areaName": "小区名称",
    "enbId": "基站标识",
    "insertNum": "请输入数字",
    "programException": "程序异常中断",
    "taskStatus": "任务状态",
    "groupMemberExport": "组成员导出",
    "downloadResult": "结果下载",
    "qryGroupList": "查询组呼列表",
    "zoomIn": "放大",
    "participantType": "用户类型",
    "importSuccess": "导入成功",
    "importFailed": "导入失败",
    "importIgnore": "导入忽略",
    "importTotal": "导入总数",
    "require": "该项不能为空",
    "groupList": "组呼列表",
    "userPrivilege": "用户特权",
    "charAt63": "请输入63位以内字符",
    "blackListDealType": "黑名单处理方式",
    "rangeLat": "请输入[-180,180]的经度",
    "groupMemberManage": "组成员管理",
    "cancle": "取消",
    "dispatchFail": "分发失败",
    "registerStatus": "在线状态",
    "ordinaryUser": "普通用户",
    "taskName": "任务名称",
    "chooseAreaGroup": "非区域组不能设置呼叫区域",
    "isCover": "是否覆盖",
    "charAt1And63": "请输入1-63位字符",
    "dataValidationFailed": "表格数据校验失败",
    "partiallyImportSuccess": "导入部分成功",
    "organizationError": "组织架构错误",
    "importingUser": "正在导入用户",
    "taskEnd": "任务结束",
    "dataBusiness": "数据业务",
    "waittingResult": "等待结果",
    "skip": "跳过",
    "cell": "小区",
    "userPriority": "用户优先级",
    "waitting": "等待中",
    "closeDrawMode": "关闭绘图模式",
    "addArea": "添加小区",
    "recieveMML": "正在接收MML",
    "offline": "离线",
    "vpn0CantAddGroup": "组织架构根节点不允许增加组",
    "gpsGroupCallManage": "呼叫区域管理",
    "neOffLine": "网元不在线",
    "executionResult": "执行结果",
    "blackList": "黑名单",
    "startTime": "开始时间",
    "groupInfo": "群组信息",
    "addGroup": "新增群组",
    "areaGroup": "区域组",
    "groupOverSheet": "超过组单sheet的最大值",
    "excelReadError": "读取Excel表格错误",
    "templateDownload": "模板下载",
    "numAt63": "请输入0-63位数字",
    "areaList": "小区",
    "refresh": "刷新",
    "updateTime": "更新时间",
    "emerGrpOrEmerUsr": "紧急单呼号码和紧急组呼号码只能配置一个！",
    "addUserManagement": "开户管理",
    "kill": "遥毙态",
    "complate": "完成",
    "confirm": "确定",
    "numOrChar": "请输入数字或英文",
    "areaId": "小区索引",
    "createTime": "创建时间",
    "resultDetail": "结果详情",
    "openDrawMode": "打开绘图模式",
    "chooseNe": "请选择网元!",
    "qry": "查询",
    "manageBlackNum": "黑名单管理",
    "endTime": "结束时间",
    "organizationImport": "组织架构信息导入",
    "inputLat": "请输入纬度(度)",
    "taskStep": "当前步骤",
    "dc": "系统调度台",
    "batchImportManagement": "批量管理导入",
    "userGroupMemberImport": "用户\u0026组\u0026隶属关系导入",
    "userNum": "用户号码",
    "importingGroupMember": "正在导入隶属关系",
    "groupExport": "组导出",
    "addUser": "新增用户",
    "unzipFailed": "解压缩zip文件错误",
    "num": "项",
    "stun": "遥晕态",
    "importingResult": "正在导入结果",
    "batchManagement": "批量管理",
    "noSpecialChar": "不允许输入特殊字符",
    "batchManagementDetail": "批量管理明细",
    "export": "导出",
    "cannotaddtocell": "不能对此种用户类型进行用户区域授权",
    "add": "添加",
    "all": "全部",
    "passwordEqual": "密码与确认密码要保持一致",
    "addBlackNum": "添加黑名单",
    "groupMemOverSheer": "超过隶属关系单sheet的最大值",
    "messageInfo": "日志",
    "groupCallImport": "组区域信息导入",
    "netType": "网络类型",
    "filed": "失败",
    "egci": "小区标识",
    "groupNum": "群组号码",
    "cellId": "小区号",
    "groupAreaDealType": "组区域处理方式",
    "addGroupMember": "添加组成员",
    "nozonegrp": "区域开关关闭时不允许设置区域组",
    "addConfirm": "确认添加？",
    "templateNotFound": "数据库中查询不到相关的模板信息",
    "importingOrgaintion": "正在导入组织架构",
    "rangeLng": "请输入[-90,90]的纬度",
    "checkingData": "数据校验中",
    "modArea": "修改小区",
    "groupType": "群组类型",
    "locate": "定位",
    "vpn0CantAddUser": "组织架构根节点不允许增加用户",
    "userOverSheet": "超过用户单sheet的最大值",
    "staticGroup": "静态组",
    "description": "描述",
    "admin": "管理员",
    "userAuthAreaImport": "用户授权区域信息导入",
    "superUser": "超级用户",
    "batchImportModify": "批量管理修改",
    "running": "运行中",
    "serviceException": "服务异常",
    "importType": "导入类型",
    "taskType": "任务类型",
    "onlyData": "请选择一条数据!",
    "dynamicGroup": "动态组",
    "groupMember": "组成员",
    "userAlias": "用户别名",
    "groupAlias": "组别名",
    "emerGrpAlarmOrEmerUsrAlarm": "紧急告警号码和紧急告警组号码只能配置一个！",
    "working": "工作态",
    "plmnId": "PLMN标识",
    "manageAreaNum": "管理用户区域授权",
    "process": "进度",
    "dcWarn": "调度台用户不能设置为转移号码",
    "groupOwner": "组所有者",
    "addAreaNum": "添加用户区域授权",
    "importingGroup": "正在导入组",
    "allImportFailed": "导入全部失败",
    "videoBusiness": "视频业务",
    "mobile": "车台",
    "vpn0CantAddUsOrMo": "组织架构根节点不允许增加SIP终端/车台",
    "deleteConfirm": "确认删除？",
    "modGroup": "修改群组",
    "cellImport": "小区信息导入",
    "groupCall": "呼叫区域",
    "timeOut": "超时",
    "notAllowedChinese": "不允许输入中文",
    "charAt6And63": "请输入6-63位字符",
    "getResponseFailed": "获取响应失败",
    "inputLng": "请输入经度(度)",
    "charAt254": "请输入254位以内字符",
    "chooseData": "请选择数据！",
    "modUser": "修改用户",
    "online": "在线",
    "superSearch": "高级搜索",
    "choosed": "已选择",
    "groupMemberDealType": "组成员处理方式",
    "user": "SIP终端",
    "menuTitleAreaMcs": "开户管理/MCS管理/用户区域管理",
    "append": "追加"
  },
  "Topo": {
    "devType": "设备类型",
    "cancel": "取消",
    "modifySuccess": "修改成功",
    "nePGW": "PGW",
    "neModify": "修改网元",
    "showTips": "显示信息",
    "devAttriTrunk": "归属集群",
    "bStation": "设备管理",
    "devAdd": "添加设备",
    "addTrunk": "新增集群",
    "trunkSelect": "请先选择集群类型",
    "deviBS": "iBS",
    "memoryUse": "内存使用",
    "fullScreen": "全屏",
    "devMange": "设备管理",
    "trunkManager": "集群管理",
    "serviceContainer": "服务Container",
    "trunkAdd": "添加集群",
    "sureDel": "确定要删除吗?",
    "delDeviceMessage": "此操作将会删除网元基站的全部信息，删除后如需要请重新添加.",
    "devID": "设备ID",
    "neDBS": "DBS",
    "restartCount": "重启次数",
    "latitude": "纬度",
    "ne5gDU": "5G-DU",
    "nelementMana": "EPC管理",
    "forbidDel": "此IP和端口不允许删除",
    "neMC_PF": "MC_PF",
    "devgNB": "GNB",
    "addSuccess": "添加成功",
    "deleteSubnet": "删除子网",
    "search": "搜索",
    "topoManagerAndTopoMonitor": "拓扑管理/拓扑监控",
    "pleaseEnterNeName": "请输入网元名称",
    "devSoftVersion": "软件版本",
    "bakSoftVersion": "备份软件版本",
    "hiddenTips": "隐藏信息",
    "neCU": "CU",
    "noAddMore": "不能再添加了",
    "trunkName": "集群名称",
    "neBM_SC": "BM-SC",
    "servicePOD": "服务 POD",
    "neMCE": "MCE",
    "deviBSB": "iBS-B",
    "cpuRatio": "CPU使用率",
    "longitudePlaceholder": "请输入经度-180~180",
    "refresh": "拓扑结构发生变化，即将刷新页面",
    "delDev": "删除设备",
    "delNeFailedForRealTaskMsg": "删除失败, 请先删除此网元[{0}]下的实时任务",
    "noSelectTrunk": "该设备类型不允许选择归属集群",
    "confirm": "确定",
    "subnetFilterPlaceHolder": "节点类型 /节点名称",
    "devDescription": "设备描述",
    "trunkHyTalk": "HyTalk",
    "updateSubnet": "修改子网",
    "subnetType": "子网类型",
    "mountNode": "挂载节点",
    "addDev": "新增设备",
    "topoRack": "机架图",
    "trunkId": "集群ID",
    "nePCDR": "PCDR",
    "elementTree": "网元树",
    "delNe": "删除网元",
    "cmdline": "命令行",
    "runningStatus": "运行状态",
    "devhytalk": "HyTalk",
    "neTCF": "TCF",
    "SubnetAtLeastTwoNodes": "子网内至少两个节点或一个子网",
    "saveTopo": "保存拓扑",
    "neMC_GMS": "MC_GMS",
    "topoMonitorPhysicalGraph": "物理视图",
    "devEPC": "EPC服务器",
    "parentNode": "父节点",
    "devName": "设备名称",
    "nodeType": "节点类型",
    "revertScale": "恢复1:1",
    "subnetNumFour": "子网层级最多为4层",
    "selectAll": "全选",
    "altitudeIllegal": "输入值必须在-9999到9999之间",
    "success": "成功",
    "invalidInt": "无效的整数",
    "name": "名称",
    "neDU": "DU",
    "nodeId": "节点ID",
    "permissionDenied": "无权限",
    "inputRangeIllegal": "输入值必须在1到65535之间",
    "devPort": "通信端口",
    "editDev": "修改设备",
    "serviceId": "服务ID",
    "trunkNelist": "挂载网元",
    "serveDetail": "服务详情",
    "devBelongSubnet": "归属子网",
    "neDev": "归属设备",
    "ipIllegal": "请输入合法IP",
    "devCrumb": "拓扑管理/资源管理/设备管理",
    "equipmentList": "设备列表",
    "service": "服务",
    "devAttriSelect": "请先选择归属设备",
    "nePCRF": "PCRF",
    "emap": "拓扑管理/电子地图",
    "deveNodeB": "eNodeB",
    "devegNodeB":"gNodeB",
    "subnetMan": "子网管理",
    "pleaseSelect": "请选择数据!",
    "ipPortDup": "IP和端口重复",
    "noData": "没有数据",
    "topoLoad": "加载..",
    "neType": "网元类型",
    "pleaseEnterDeviceName": "请输入设备名称",
    "neODBBU": "ODBBU",
    "devhytalkPro": "HyTalk Pro",
    "nePRES": "PRES",
    "neTypeForSubnet": "网元类型",
    "id": "ID",
    "neID": "网元ID",
    "devMCS": "MCS服务器",
    "memoryUsage": "内存使用率",
    "ip": "IP",
    "topoMonitorLogicalGraph": "逻辑视图",
    "noAttriTrunk": "不归属任何集群",
    "deveNodeBIOPS": "eNodeB-IOPS",
    "devIpPort": "通信IP\u0026通信端口",
    "noEmptyStart": "名称禁止用空格开头",
    "subnetDes": "子网描述",
    "neP_HSS": "P_HSS",
    "netTypeImg": "网元图例",
    "neMC_GMS_NODE": "MC_GMS_NODE",
    "status": "状态",
    "nodeName": "节点名称",
    "topoMaxLength": "文字长度不能超过",
    "devAttriSubnet": "请选择归属子网",
    "neiBS_B": "iBS-B",
    "addSubnet": "新增子网",
    "devModify": "修改设备",
    "memRatio": "内存使用率",
    "neSGW": "SGW",
    "neAdd": "添加网元",
    "neMC_IDMS": "MC_IDMS",
    "devSelect": "请先选择设备类型",
    "deviceUpdate": "设备升级",
    "backPrevious": "返回上一级",
    "neSelect": "请先选择网元类型",
    "editNe": "修改网元",
    "topoRerefresh": "刷新列表",
    "childNode": "子节点",
    "pleaseSelectOne": "请选择一条数据!",
    "latitudePlaceholder": "请输入纬度-90~90",
    "altitudePlaceholder": "请输入海拔高度-9999~9999",
    "cummunicateIPPort": "通信IP和端口",
    "cpuUsage": "CPU使用率",
    "emptySubnet": "不能创建空子网",
    "dockerContainerId": "容器名称",
    "delTrunk": "删除集群",
    "devThread": "进程号",
    "neName": "网元名称",
    "deviceReback": "设备回退",
    "processName": "进程名称",
    "containerName": "容器名称",
    "excelLayout": "表格布局",
    "bStationEdition": "设备版本管理",
    "patchVersion": "补丁包版本",
    "patchVersionUpgrade": "补丁包升级管理",
    "devicePatchRollback":" 补丁回退",
    "neList": "网元列表",
    "topoManager": "拓扑管理",
    "longitude": "经度",
    "neMBMS_GW": "MBMS-GW",
    "longitudeIllegal": "输入值必须在-180到180之间",
    "devManager": "设备管理",
    "ne5gCU": "5G-CU",
    "neMC_KMS": "MC_KMS",
    "servicePID": "服务进程",
    "neCrumb": "拓扑管理/资源管理/网元管理",
    "physicalIP": "物理IP",
    "invalidIPAddress": "无效的IP地址。例如：192.168.69.1",
    "neHSS": "HSS",
    "devIp": "通信IP",
    "neMC_CMS": "MC_CMS",
    "neMME": "MME",
    "trunkCrumb": "拓扑管理/资源管理/集群管理",
    "devODBBU": "ODBBU",
    "neManager": "网元管理",
    "nePDTGW": "PDTGW",
    "podName": "POD名称",
    "neDevSelect": "请先选择归属集群",
    "addNe": "新增网元",
    "altitude": "海拔高度(m)",
    "trunkModify": "修改集群",
    "latitudeIllegal": "输入值必须在-90到90之间",
    "neDescription": "网元描述",
    "error": "失败",
    "neFRS": "FRS",
    "portIllegal": "范围应为1024-65535",
    "subnetName": "子网名称",
    "envirommentName": "集群名称",
    "nameSpace": "命名空间",
    "ok": "确定",
    "subnetID": "子网ID",
    "editTrunk": "修改集群",
    "neMC_TMF": "MC_TMF",
    "delSuccess": "删除成功",
    "topoSearchEquipment": "搜索设备",
    "neTMF": "TMF",
    "serviceName": "服务名称",
    "neDMS": "DMS",
    "physicalPort": "物理端口",
    "neMange": "网元管理",
    "trunkMC_CF": "MCS",
    "neMC_CF": "MC_CF",
    "trunkCode": "集群类型",
    "neeNodeB": "eNodeB",
    "trunkMange": "集群管理",
    "trunkDescription": "集群描述",
    "pmTaskExist": "此基站有性能任务，不能删除",
  },
  "Track": {
    "filterConditions": "过滤条件",
    "struct": "结构体",
    "cancel": "取消",
    "neId": "网元ID",
    "fileName": "文件名称",
    "maximumMissionNumber": "任务跟踪数量最多为5个!",
    "taskDeletion": "删除任务",
    "signManage": "信令管理",
    "resourcesList": "资源列表",
    "publicMessage": "公共消息",
    "taskTracking": "任务跟踪",
    "messageType": "消息类型",
    "realTimeFiltering": "实时过滤",
    "text": "文本",
    "issued": "待下发",
    "taskID": "任务ID",
    "taskStatus": "任务状态",
    "suspendTask": "挂起任务",
    "active": "执行",
    "realTime": "实时",
    "downloadFile": "下载文件",
    "mission": "跟踪",
    "stop": "暂停",
    "taskName": "任务名称",
    "detail": "详情",
    "queryTrack": "信令查询",
    "createTask": "创建任务",
    "status": "状态",
    "taskSrc": "任务来源",
    "greate": "待执行",
    "autoActivationFailed": "自动激活失败",
    "save": "保存",
    "taskList": "任务列表",
    "refreshTask": "刷新任务",
    "addTask": "添加任务",
    "result": "执行结果",
    "search": "查询",
    "file": "文件",
    "creatTime": "创建时间",
    "pleaseSelectNE": "请选择资源",
    "pleaseSelectEffect": "请选择待执行或待下发或挂起的状态进行操作",
    "noDataToExport": "没有数据无法导出",
    "taskIsPending": "任务处于挂起状态",
    "startTime": "开始时间",
    "operating": "操作",
    "endTimeGreaterThanStartTime": "结束时间应大于开始时间",
    "close": "关闭",
    "historyFilter": "历史过滤",
    "resourceID": "资源ID",
    "systemId": "系统ID",
    "expression": "表达式",
    "activationTask": "激活任务",
    "filter": "过滤",
    "confirm": "确认",
    "taskTypeID": "模版ID",
    "downloadExcel": "下载Excel",
    "endTime": "结束时间",
    "complete": "完成",
    "resourceType": "资源类型",
    "searchNe": "搜索网元",
    "reIssued": "重新下发",
    "neName": "网元名称",
    "trackingCommunity": "跟踪小区",
    "hangup": "挂起",
    "pleaseEnterQuery": "请输入查询条件",
    "reportType": "上报类型",
    "download": "下载",
    "finish": "完成",
    "export": "导出",
    "taskDetails": "任务详情",
    "importTrackData": "信令数据导入",
    "all": "全部",
    "add": "添加",
    "signalingDetails": "信令详情",
    "tracing": "执行中",
    "attributeValues": "属性值",
    "resourceName": "资源名称",
    "queryError": "查询错误",
    "notGenerated": "未生成相关文件",
    "updateTask": "编辑任务",
    "importFileError": "导入文件错误",
    "deleteTaskInfo": "删除任务会同时删除相关的上报文件，是否删除该任务？",
    "success": "成功",
    "monitorTrack": "任务监控",
    "standardInterface": "标准接口",
    "activation": "激活",
    "missionAlreadyCompleted": "任务已经完成",
    "import": "导入",
    "taskInProgress": "任务正在执行中",
    "measuringObject": "测量对象",
    "signTrack": "信令跟踪",
    "NElist": "网元列表",
    "error": "失败",
    "delete": "删除",
    "pleaseSelectMeasuringObject": "请选择测量对象",
    "attributeName": "属性名称",
    "signalDataExport": "信令数据导出",
    "userTrack": "用户跟踪",
    "missionCompleted": "完成任务",
    "deleteFile": "是否删除文件？",
    "searchResource": "搜索资源",
    "implementation": "执行中",
    "fieldIsRequired": "该项不能为空",
    "pleaseEnterQueryName": "请输入任务名称",
    "systemOutTime": "系统连接超时",
    "pleaseSelect": "请选择",
    "time": "时间",
    "internalSignaling": "内部信令",
    collapseAllNodes: '全部折叠',
    expandAllNodes: '全部展开',
    invalidFile: '无效的文件格式',
  },
  "TS": {
    "callSetUpTimeCount": "呼叫建立时长数量",
    "singleCallSetUpTime": "单周期呼叫建立时长次数",
    "ts_ok": "确定",
    "time1day": "1 天",
    "ts_chart_firstNumber_bigerthan0": "数字必须大于0!",
    "startDateNoEqualsEndDate": "开始日期与结束日期不能相同!",
    "ts__task_name_userCount": "在线用户数任务",
    "starttime": "开始日期",
    "ts_cancell": "取消",
    "taskState": "任务状态",
    "sendTimeHeader": "发送时间",
    "registerStatusHeader": "注册状态",
    "emergencyCallStatus_0": "非紧急呼叫",
    "emergencyCallStatus_1": "紧急呼叫",
    "ts_cannot_operate": "不能进行此操作！",
    "configTimeRange": "呼叫建立时长区间边界值",
    "ts_neOffLine": "网元不在线！",
    "neID": "网元ID",
    "statisticsTime": "统计时间",
    "timeDay": "天",
    "ts_back_must_larger_than_pre": "后一个值必须大于前一个值!",
    "ts_call_isCaller": "呼叫标识",
    "ts_fail": "操作失败！",
    "onlineUsereStatistics": "在线用户数统计",
    "registerTime": "操作时间",
    "ts_call_beginTime": "发起呼叫的时间",
    "onlineUserRegisterCount": "总注册",
    "callingTypeStatus_7": "车台",
    "callingTypeStatus_8": "ULP用户",
    "registerAddress": "操作地址",
    "callingTypeStatus_9": "组号码",
    "ts_xAxis": "X坐标",
    "registerStatus_0": "去登记",
    "registerStatus_1": "登记",
    "operateResult": "操作结果",
    "ts_call_audioCode": "语音编码格式",
    "callingTypeStatus_0": "未知类型",
    "callingTypeStatus_1": "SIP终端",
    "taskName": "任务名称",
    "interval": "时间间隔",
    "callingTypeStatus_2": "双模终端",
    "callingTypeStatus_3": "录音/录像服务器",
    "registerStatus_2": "登记失败",
    "ts_call_callType": "呼叫类型",
    "callingTypeStatus_4": "PNAS终端",
    "registerStatus_3": "周期注册",
    "callingTypeStatus_5": "系统调度台",
    "ts_call_callingAddress": "主叫方号码",
    "callingTypeStatus_6": "调度台坐席",
    "numHeader": "号码",
    "gs_search": "高级搜索",
    "ts_call_setup_time": "单周期呼叫建立时长(毫秒)",
    "dailyActivityCount": "日活数量",
    "callCauseStatus_1": "成功",
    "callCauseStatus_0": "失败",
    "ts__task_name_data": "数据任务",
    "searchByNumHolder": "请输入搜索号码",
    "callCount": "呼叫总数",
    "ts_chart_illegal_number": "非数值!",
    "time1hour": "1小时",
    "ts_digital_callType": "消息类型",
    "ts_call_callingType": "主叫方类型",
    "ts__task_name_onlineTime": "用户在线时长任务",
    "taskDetail": "任务描述",
    "ts_chart_single_video": "视频单呼",
    "ts_xAxis_time": "时间",
    "ts_call_e2EE": "加密业务指示",
    "calledAddressHeader": "被叫号码",
    "callTypeHeader": "类型",
    "timeShowHour": "小时",
    "operating": "操作",
    "alertMessage": "提示",
    "e2EEStatus_0": "未加密业务",
    "e2EEStatus_1": "端到端加密业务",
    "onlineTimeStatistics": "用户在线时长统计",
    "startDateEqualsEndDate": "请选择的开始日期与结束日期相同!",
    "ts_call_callFailReason": "呼叫失败原因",
    "endtime": "结束日期",
    "ts_call_callingTotalTime": "呼叫总时长(s)",
    "ts_task_oper_stop": "暂停",
    "ts_digital_callCause": "发送失败原因",
    "correctFormat": "请输入正确格式(最多为50个号码)",
    "ts_callee_detail": "被叫详情",
    "msgCountStatistics": "消息数据统计",
    "ts__task_name_reg": "注册任务",
    "duplexModeStatus_0": "非全双工呼叫",
    "registerCountStatistics": "注册数统计",
    "duplexModeStatus_1": "全双工呼叫",
    "startDateGreaterEndDate": "开始日期不能大于结束日期!",
    "callFailedCount": "呼叫失败数",
    "ts_information_reporting_reg": "注册信息上报",
    "ts_call_groupNum": "组号码",
    "neIDIsNull": "请选择网元",
    "ts_call_startTime": "建立呼叫的时间",
    "ts_count": "数量",
    "ts_have_stop_task": "任务已经处于暂停状态！",
    "ts_chart_xAxis_positive_integer": "请输入正整数！",
    "operation": "操作",
    "ts_call_duplexMode": "是否全双工呼叫",
    "ts_call_endTime": "呼叫结束的时间",
    "ts_information_reporting_call": "语音信息上报",
    "singleCallFailedCount": "单周期呼叫失败数",
    "acceptTimeHeader": "受理时间",
    "neName": "网元名称",
    "time15min": "15分钟",
    "unReg_1": "系统",
    "unReg_0": "终端",
    "ts_chart_atleast_two_numbers": "至少输入两个数!",
    "operateResult_1": "成功",
    "operateResult_0": "失败",
    "datetime": "日期",
    "callFailureCountStatistics": "呼叫失败数统计",
    "unReg": "发起方",
    "ts_call_emergencyCall": "紧急呼叫指示",
    "ts_call_type": "呼叫类型",
    "timeMonth": "月",
    "userNumber": "用户号码",
    "configTime": "呼叫建立时长区间",
    "onlineUserAllCount": "总开户数",
    "timeShowMin": "分",
    "ts_chart_group_call": "语音组呼",
    "sendResult": "发送结果",
    "ts_task_oper_start": "开始",
    "dailyActivityStatistics": "日活统计",
    "ts_number_not_null": "中间数值不能为空!",
    "callingAddressHeader": "主叫号码",
    "callCountStatistics": "呼叫数量统计",
    "ts_information_reporting_userCount": "在线用户数信息上报",
    "ts_chart_single_call": "语音单呼",
    "ts_neList": "网元列表",
    "callServiceStatistics": "呼叫业务统计",
    "success": "成功",
    "ts_digital_isCaller": "消息标识",
    "ts_information_reporting_onlineTime": "用户在线时长信息上报",
    "trafficTaskManagement": "任务管理",
    "registerServiceStatistics": "注册业务统计",
    "taskState_0": "暂停",
    "terminalType_9": "组号码",
    "taskState_1": "执行",
    "ts_information_reporting_data": "数据信息上报",
    "terminalType_4": "PNAS终端",
    "terminalType_3": "录音/录像服务器",
    "terminalType_2": "双模终端",
    "terminalType_1": "SIP终端",
    "terminalType_8": "ULP用户",
    "startDateMaxEndDate": "最大支持查询31天!",
    "terminalType_7": "车台",
    "terminalType_6": "调度台坐席",
    "ts_call_detail": "详情",
    "digitalServiceStatistics": "数据业务统计",
    "terminalType_5": "系统调度台",
    "msgCallType_4": "群组多媒体消息",
    "dataLenHeader": "数据大小(字节)",
    "onlineTime": "在线时长",
    "msgCallType_5": "广播消息",
    "msgCallType_2": "群组消息",
    "msgCallType_3": "点对点多媒体消息",
    "terminalType_0": "未知类型",
    "msgTypeDetailTitle": "数据详单统计",
    "ts_call_callCause": "呼叫建立结果",
    "msgCallType_1": "点对点消息",
    "searchByCallerHolder": "请输入呼叫号码",
    "ts_chart_broadcast_call": "广播呼叫",
    "ts_chart_group_video": "视频组呼",
    "trafficMeasurement": "话务统计",
    "ts_call_calledType": "被叫方类型",
    "callSetUpTimeStatistics": "呼叫平均建立时长统计",
    "ts_register_callCause": "失败原因",
    "selectNeIDIsNull": "请在搜索框中选择网元",
    "startDateIsNull": "开始日期不能为空!",
    "endDateIsNull": "结束日期不能为空！",
    "ts_call_calledAddress": "被叫方号码",
    "isCallerStatus_0": "被叫",
    "ts_call_priority": "呼叫优先级",
    "isCallerStatus_1": "主叫",
    "ts__task_name_call": "呼叫任务",
    "opTime": "操作时间",
    "ts_have_start_task": "任务已经处于执行状态！",
    "ts_average_time": "平均建立时长(毫秒)",
    "terminalTypeHeader": "终端类型",
    "ts_search": "查询",
    "registerTypeDetailTitle": "注册详单统计"
  },
  "ErrorCode": {
    "16001": "CM服务进程已停止,导致PM服务进程无法停止",
    "16002": "CM服务进程已停止,导致PM服务进程无法启动",
    "16003": "CM服务进程已停止,无法执行配置相关操作",
    "16004": "同一时刻只能有一个用户执行备份，请稍后执行...",
    "16005": "任务在执行中，请稍后尝试...",
  }
};
